/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export interface IAgencyMapServiceProxy {
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAll(authorization: string | null | undefined): Observable<B3GResponseOfListOfAgenceMapOutputDto>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAvailableCities(authorization: string | null | undefined): Observable<B3GResponseOfListOfCityOutputModel>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAgenciesByCity(model: GetAgencyMapInputModel, authorization: string | null | undefined): Observable<B3GResponseOfListOfAgenceMapOutputDto>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAgency(model: GetAgencyMapInputModel, authorization: string | null | undefined): Observable<B3GResponseOfAgenceMapOutputDto>;
}

@Injectable()
export class AgencyMapServiceProxy implements IAgencyMapServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

   /* constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://www.e-cihbank.ma:90/";
    }
    */
    constructor(
        @Inject(HttpClient) http: HttpClient,
        @Inject('API_BASE_URL') private apiBaseUrl: string
      ) {
        this.http = http;
        this.baseUrl = apiBaseUrl;
      }


    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAll(authorization: string | null | undefined): Observable<B3GResponseOfListOfAgenceMapOutputDto> {
        let url_ = this.baseUrl + "/api/AgencyMap/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfAgenceMapOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfAgenceMapOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<B3GResponseOfListOfAgenceMapOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfAgenceMapOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfAgenceMapOutputDto>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAvailableCities(authorization: string | null | undefined): Observable<B3GResponseOfListOfCityOutputModel> {
        let url_ = this.baseUrl + "/api/AgencyMap/GetAvailableCities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableCities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableCities(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfCityOutputModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfCityOutputModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvailableCities(response: HttpResponseBase): Observable<B3GResponseOfListOfCityOutputModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfCityOutputModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfCityOutputModel>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAgenciesByCity(model: GetAgencyMapInputModel, authorization: string | null | undefined): Observable<B3GResponseOfListOfAgenceMapOutputDto> {
        let url_ = this.baseUrl + "/api/AgencyMap/GetAgenciesByCity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgenciesByCity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgenciesByCity(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfAgenceMapOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfAgenceMapOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgenciesByCity(response: HttpResponseBase): Observable<B3GResponseOfListOfAgenceMapOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfAgenceMapOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfAgenceMapOutputDto>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAgency(model: GetAgencyMapInputModel, authorization: string | null | undefined): Observable<B3GResponseOfAgenceMapOutputDto> {
        let url_ = this.baseUrl + "/api/AgencyMap/GetAgency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgency(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfAgenceMapOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfAgenceMapOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAgency(response: HttpResponseBase): Observable<B3GResponseOfAgenceMapOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfAgenceMapOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfAgenceMapOutputDto>(<any>null);
    }
}

export interface IAuthServiceProxy {
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    login(loginInput: LoginInput, authorization: string | null | undefined): Observable<B3GResponseOfLoginOutput>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    loginEER(model: LoginEERInput, authorization: string | null | undefined): Observable<B3GResponseOfLoginOutput>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    logout(logoutInput: LogoutInput, authorization: string | null | undefined): Observable<B3GResponseOfLogoutOutput>;
}

@Injectable()
export class AuthServiceProxy implements IAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /*constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://www.e-cihbank.ma:90/";
    }*/

    constructor(
        @Inject(HttpClient) http: HttpClient,
        @Inject('API_BASE_URL') private apiBaseUrl: string
      ) {
        this.http = http;
        this.baseUrl = apiBaseUrl;
      }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    login(loginInput: LoginInput, authorization: string | null | undefined): Observable<B3GResponseOfLoginOutput> {
        let url_ = this.baseUrl + "/api/Auth/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfLoginOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfLoginOutput>><any>_observableThrow(response_);
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<B3GResponseOfLoginOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfLoginOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfLoginOutput>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    loginEER(model: LoginEERInput, authorization: string | null | undefined): Observable<B3GResponseOfLoginOutput> {
        let url_ = this.baseUrl + "/api/Auth/LoginEER";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginEER(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginEER(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfLoginOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfLoginOutput>><any>_observableThrow(response_);
        }));
    }

    protected processLoginEER(response: HttpResponseBase): Observable<B3GResponseOfLoginOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfLoginOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfLoginOutput>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    logout(logoutInput: LogoutInput, authorization: string | null | undefined): Observable<B3GResponseOfLogoutOutput> {
        let url_ = this.baseUrl + "/api/Auth/Logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(logoutInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfLogoutOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfLogoutOutput>><any>_observableThrow(response_);
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<B3GResponseOfLogoutOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfLogoutOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfLogoutOutput>(<any>null);
    }
}

export interface ICountryServiceProxy {
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAll(authorization: string | null | undefined): Observable<B3GResponseOfListOfCountryDto>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getCities(authorization: string | null | undefined): Observable<B3GResponseOfListOfString>;
}

@Injectable()
export class CountryServiceProxy implements ICountryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /* constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://www.e-cihbank.ma:90/";
    }*/

    constructor(
        @Inject(HttpClient) http: HttpClient,
        @Inject('API_BASE_URL') private apiBaseUrl: string
      ) {
        this.http = http;
        this.baseUrl = apiBaseUrl;
      }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAll(authorization: string | null | undefined): Observable<B3GResponseOfListOfCountryDto> {
        let url_ = this.baseUrl + "/api/Country/GetListCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfCountryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfCountryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<B3GResponseOfListOfCountryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfCountryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfCountryDto>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getCities(authorization: string | null | undefined): Observable<B3GResponseOfListOfString> {
        let url_ = this.baseUrl + "/api/Country/GetCities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCities(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfString>><any>_observableThrow(response_);
        }));
    }

    protected processGetCities(response: HttpResponseBase): Observable<B3GResponseOfListOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfString>(<any>null);
    }
}

export interface IDataFromBDServiceProxy {
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAllSecteur(authorization: string | null | undefined): Observable<B3GResponseOfListOfSecteurActivite>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAllMotif(authorization: string | null | undefined): Observable<B3GResponseOfListOfMotif>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAllOrigine(authorization: string | null | undefined): Observable<B3GResponseOfListOfOrigineDeFonds>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAllSituationFamiliale(authorization: string | null | undefined): Observable<B3GResponseOfListOfSituationFamilial>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAllMotivationCompte(authorization: string | null | undefined): Observable<B3GResponseOfListOfMotivationOuverture>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getListAppoitement(authorization: string | null | undefined): Observable<B3GResponseOfListOfApointementDTO>;
}

@Injectable()
export class DataFromBDServiceProxy implements IDataFromBDServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /*constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://www.e-cihbank.ma:90/";
    }*/

    constructor(
        @Inject(HttpClient) http: HttpClient,
        @Inject('API_BASE_URL') private apiBaseUrl: string
      ) {
        this.http = http;
        this.baseUrl = apiBaseUrl;
      }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAllSecteur(authorization: string | null | undefined): Observable<B3GResponseOfListOfSecteurActivite> {
        let url_ = this.baseUrl + "/api/DataFromBD/GetSecteur";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSecteur(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSecteur(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfSecteurActivite>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfSecteurActivite>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSecteur(response: HttpResponseBase): Observable<B3GResponseOfListOfSecteurActivite> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfSecteurActivite.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfSecteurActivite>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAllMotif(authorization: string | null | undefined): Observable<B3GResponseOfListOfMotif> {
        let url_ = this.baseUrl + "/api/DataFromBD/GetMotif";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMotif(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMotif(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfMotif>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfMotif>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMotif(response: HttpResponseBase): Observable<B3GResponseOfListOfMotif> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfMotif.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfMotif>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAllOrigine(authorization: string | null | undefined): Observable<B3GResponseOfListOfOrigineDeFonds> {
        let url_ = this.baseUrl + "/api/DataFromBD/GetOrigineFonds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrigine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrigine(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfOrigineDeFonds>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfOrigineDeFonds>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllOrigine(response: HttpResponseBase): Observable<B3GResponseOfListOfOrigineDeFonds> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfOrigineDeFonds.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfOrigineDeFonds>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAllSituationFamiliale(authorization: string | null | undefined): Observable<B3GResponseOfListOfSituationFamilial> {
        let url_ = this.baseUrl + "/api/DataFromBD/GetSituationFamilialle";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSituationFamiliale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSituationFamiliale(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfSituationFamilial>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfSituationFamilial>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSituationFamiliale(response: HttpResponseBase): Observable<B3GResponseOfListOfSituationFamilial> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfSituationFamilial.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfSituationFamilial>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAllMotivationCompte(authorization: string | null | undefined): Observable<B3GResponseOfListOfMotivationOuverture> {
        let url_ = this.baseUrl + "/api/DataFromBD/GetAllMotivationCompte";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMotivationCompte(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMotivationCompte(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfMotivationOuverture>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfMotivationOuverture>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMotivationCompte(response: HttpResponseBase): Observable<B3GResponseOfListOfMotivationOuverture> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfMotivationOuverture.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfMotivationOuverture>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getListAppoitement(authorization: string | null | undefined): Observable<B3GResponseOfListOfApointementDTO> {
        let url_ = this.baseUrl + "/api/DataFromBD/GetListAppoitement";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListAppoitement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListAppoitement(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfApointementDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfApointementDTO>><any>_observableThrow(response_);
        }));
    }

    protected processGetListAppoitement(response: HttpResponseBase): Observable<B3GResponseOfListOfApointementDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfApointementDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfApointementDTO>(<any>null);
    }
}

export interface IIdentityServiceProxy {
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    activateStepOne(model: CheckUser, authorization: string | null | undefined): Observable<B3GResponseOfActivateStepOneOutputModel>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    activateStepTwo(model: Otp, authorization: string | null | undefined): Observable<B3GResponseOfActivationStepTwoOutput>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    activateStepThree(model: SecretsModel, authorization: string | null | undefined): Observable<B3GResponseOfActivateStepThreeOutputModel>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mpoStepOne(model: CheckUser, authorization: string | null | undefined): Observable<B3GResponseOfMpoStepOneOutput>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mpoStepTwo(model: Otp, authorization: string | null | undefined): Observable<B3GResponseOfMpoStepTwoOutput>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mpoStepThree(model: CheckAnswer, authorization: string | null | undefined): Observable<B3GResponseOfString>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mpoStepFour(model: PasswordModel, authorization: string | null | undefined): Observable<B3GResponseOfString>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mpoStepOneCih(model: CheckUser, authorization: string | null | undefined): Observable<B3GResponseOfMpoStepTwoOutput>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mpoStepTwoCih(model: Answer, authorization: string | null | undefined): Observable<B3GResponseOfMpoStepOneOutput>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mpoStepThreeCih(model: Otp, authorization: string | null | undefined): Observable<B3GResponseOfActivationStepTwoOutput>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mpoStepFourCih(model: CustomerData, authorization: string | null | undefined): Observable<B3GResponseOfString>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    forgotPasswordOne(model: CheckMailProspectInput, authorization: string | null | undefined): Observable<B3GResponseOfString>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    forgotPasswordTwo(model: CheckTokenInput, authorization: string | null | undefined): Observable<B3GResponseOfString>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    forgotPasswordThree(model: ChangePasswordInput, authorization: string | null | undefined): Observable<B3GResponseOfString>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getUserDevices(authorization: string | null | undefined): Observable<B3GResponseOfCollectionOfApplicationUserDeviceDto>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    checkNumberPhoneSendPhonenumber(phone: CheckPhoneNumberInput, authorization: string | null | undefined): Observable<B3GResponseOfString>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    confirmchangepassword(modeconfirmpass: ConfirmChangePasswordInput, authorization: string | null | undefined): Observable<B3GResponseOfString>;
}

@Injectable()
export class IdentityServiceProxy implements IIdentityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

   /* constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://www.e-cihbank.ma:90/";
    }*/

    constructor(
        @Inject(HttpClient) http: HttpClient,
        @Inject('API_BASE_URL') private apiBaseUrl: string
      ) {
        this.http = http;
        this.baseUrl = apiBaseUrl;
      }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    activateStepOne(model: CheckUser, authorization: string | null | undefined): Observable<B3GResponseOfActivateStepOneOutputModel> {
        let url_ = this.baseUrl + "/api/identity/ActivateStepOne";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateStepOne(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateStepOne(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfActivateStepOneOutputModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfActivateStepOneOutputModel>><any>_observableThrow(response_);
        }));
    }

    protected processActivateStepOne(response: HttpResponseBase): Observable<B3GResponseOfActivateStepOneOutputModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfActivateStepOneOutputModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfActivateStepOneOutputModel>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    activateStepTwo(model: Otp, authorization: string | null | undefined): Observable<B3GResponseOfActivationStepTwoOutput> {
        let url_ = this.baseUrl + "/api/identity/ActivateStepTwo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateStepTwo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateStepTwo(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfActivationStepTwoOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfActivationStepTwoOutput>><any>_observableThrow(response_);
        }));
    }

    protected processActivateStepTwo(response: HttpResponseBase): Observable<B3GResponseOfActivationStepTwoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfActivationStepTwoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfActivationStepTwoOutput>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    activateStepThree(model: SecretsModel, authorization: string | null | undefined): Observable<B3GResponseOfActivateStepThreeOutputModel> {
        let url_ = this.baseUrl + "/api/identity/ActivateStepThree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateStepThree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateStepThree(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfActivateStepThreeOutputModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfActivateStepThreeOutputModel>><any>_observableThrow(response_);
        }));
    }

    protected processActivateStepThree(response: HttpResponseBase): Observable<B3GResponseOfActivateStepThreeOutputModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfActivateStepThreeOutputModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfActivateStepThreeOutputModel>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mpoStepOne(model: CheckUser, authorization: string | null | undefined): Observable<B3GResponseOfMpoStepOneOutput> {
        let url_ = this.baseUrl + "/api/identity/MpoStepOneUmnia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpoStepOne(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpoStepOne(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfMpoStepOneOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfMpoStepOneOutput>><any>_observableThrow(response_);
        }));
    }

    protected processMpoStepOne(response: HttpResponseBase): Observable<B3GResponseOfMpoStepOneOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfMpoStepOneOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfMpoStepOneOutput>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mpoStepTwo(model: Otp, authorization: string | null | undefined): Observable<B3GResponseOfMpoStepTwoOutput> {
        let url_ = this.baseUrl + "/api/identity/MpoStepTwoUmnia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpoStepTwo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpoStepTwo(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfMpoStepTwoOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfMpoStepTwoOutput>><any>_observableThrow(response_);
        }));
    }

    protected processMpoStepTwo(response: HttpResponseBase): Observable<B3GResponseOfMpoStepTwoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfMpoStepTwoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfMpoStepTwoOutput>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mpoStepThree(model: CheckAnswer, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/identity/MpoStepThreeUmnia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpoStepThree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpoStepThree(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processMpoStepThree(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mpoStepFour(model: PasswordModel, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/identity/MpoStepFourUmnia";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpoStepFour(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpoStepFour(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processMpoStepFour(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mpoStepOneCih(model: CheckUser, authorization: string | null | undefined): Observable<B3GResponseOfMpoStepTwoOutput> {
        let url_ = this.baseUrl + "/api/identity/MpoStepOneCih";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpoStepOneCih(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpoStepOneCih(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfMpoStepTwoOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfMpoStepTwoOutput>><any>_observableThrow(response_);
        }));
    }

    protected processMpoStepOneCih(response: HttpResponseBase): Observable<B3GResponseOfMpoStepTwoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfMpoStepTwoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfMpoStepTwoOutput>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mpoStepTwoCih(model: Answer, authorization: string | null | undefined): Observable<B3GResponseOfMpoStepOneOutput> {
        let url_ = this.baseUrl + "/api/identity/MpoStepTwoCih";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpoStepTwoCih(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpoStepTwoCih(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfMpoStepOneOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfMpoStepOneOutput>><any>_observableThrow(response_);
        }));
    }

    protected processMpoStepTwoCih(response: HttpResponseBase): Observable<B3GResponseOfMpoStepOneOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfMpoStepOneOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfMpoStepOneOutput>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mpoStepThreeCih(model: Otp, authorization: string | null | undefined): Observable<B3GResponseOfActivationStepTwoOutput> {
        let url_ = this.baseUrl + "/api/identity/MpoStepThreeCih";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpoStepThreeCih(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpoStepThreeCih(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfActivationStepTwoOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfActivationStepTwoOutput>><any>_observableThrow(response_);
        }));
    }

    protected processMpoStepThreeCih(response: HttpResponseBase): Observable<B3GResponseOfActivationStepTwoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfActivationStepTwoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfActivationStepTwoOutput>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mpoStepFourCih(model: CustomerData, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/identity/MpoStepFourCih";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMpoStepFourCih(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMpoStepFourCih(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processMpoStepFourCih(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    forgotPasswordOne(model: CheckMailProspectInput, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/identity/ForgotPasswordOne";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPasswordOne(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPasswordOne(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processForgotPasswordOne(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    forgotPasswordTwo(model: CheckTokenInput, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/identity/ForgotPasswordTwo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPasswordTwo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPasswordTwo(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processForgotPasswordTwo(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    forgotPasswordThree(model: ChangePasswordInput, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/identity/ForgotPasswordThree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPasswordThree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPasswordThree(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processForgotPasswordThree(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getUserDevices(authorization: string | null | undefined): Observable<B3GResponseOfCollectionOfApplicationUserDeviceDto> {
        let url_ = this.baseUrl + "/api/identity/GetUserDevices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDevices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDevices(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfCollectionOfApplicationUserDeviceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfCollectionOfApplicationUserDeviceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserDevices(response: HttpResponseBase): Observable<B3GResponseOfCollectionOfApplicationUserDeviceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfCollectionOfApplicationUserDeviceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfCollectionOfApplicationUserDeviceDto>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    checkNumberPhoneSendPhonenumber(phone: CheckPhoneNumberInput, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/identity/CheckNumberPhoneSendPhonenumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(phone);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckNumberPhoneSendPhonenumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckNumberPhoneSendPhonenumber(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processCheckNumberPhoneSendPhonenumber(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    confirmchangepassword(modeconfirmpass: ConfirmChangePasswordInput, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/identity/Confirmchangepassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modeconfirmpass);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmchangepassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmchangepassword(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmchangepassword(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }
}

export interface IInsuranceBankServiceProxy {
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getInsuranceBank(authorization: string | null | undefined): Observable<B3GResponseOfListOfInsuranceBankViewModel>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getInsuranceBankFutureAccount(authorization: string | null | undefined): Observable<B3GResponseOfListOfInsuranceBankFutureAccountViewModel>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getInsuranceBankFutureProvident(authorization: string | null | undefined): Observable<B3GResponseOfListOfInsuranceBankFutureProvidentViewModel>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getInsuranceBankFutureHimaya(authorization: string | null | undefined): Observable<B3GResponseOfListOfInsuranceBankFutureHimayaViewModel>;
}

@Injectable()
export class InsuranceBankServiceProxy implements IInsuranceBankServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /* constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://www.e-cihbank.ma:90/";
    }*/

    constructor(
        @Inject(HttpClient) http: HttpClient,
        @Inject('API_BASE_URL') private apiBaseUrl: string
      ) {
        this.http = http;
        this.baseUrl = apiBaseUrl;
      }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getInsuranceBank(authorization: string | null | undefined): Observable<B3GResponseOfListOfInsuranceBankViewModel> {
        let url_ = this.baseUrl + "/api/InsuranceBank/GetInsuranceBank";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInsuranceBank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInsuranceBank(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfInsuranceBankViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfInsuranceBankViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetInsuranceBank(response: HttpResponseBase): Observable<B3GResponseOfListOfInsuranceBankViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfInsuranceBankViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfInsuranceBankViewModel>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getInsuranceBankFutureAccount(authorization: string | null | undefined): Observable<B3GResponseOfListOfInsuranceBankFutureAccountViewModel> {
        let url_ = this.baseUrl + "/api/InsuranceBank/GetInsuranceBankFutureAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInsuranceBankFutureAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInsuranceBankFutureAccount(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfInsuranceBankFutureAccountViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfInsuranceBankFutureAccountViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetInsuranceBankFutureAccount(response: HttpResponseBase): Observable<B3GResponseOfListOfInsuranceBankFutureAccountViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfInsuranceBankFutureAccountViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfInsuranceBankFutureAccountViewModel>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getInsuranceBankFutureProvident(authorization: string | null | undefined): Observable<B3GResponseOfListOfInsuranceBankFutureProvidentViewModel> {
        let url_ = this.baseUrl + "/api/InsuranceBank/GetInsuranceBankFutureProvident";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInsuranceBankFutureProvident(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInsuranceBankFutureProvident(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfInsuranceBankFutureProvidentViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfInsuranceBankFutureProvidentViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetInsuranceBankFutureProvident(response: HttpResponseBase): Observable<B3GResponseOfListOfInsuranceBankFutureProvidentViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfInsuranceBankFutureProvidentViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfInsuranceBankFutureProvidentViewModel>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getInsuranceBankFutureHimaya(authorization: string | null | undefined): Observable<B3GResponseOfListOfInsuranceBankFutureHimayaViewModel> {
        let url_ = this.baseUrl + "/api/InsuranceBank/GetInsuranceBankFutureHimaya";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInsuranceBankFutureHimaya(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInsuranceBankFutureHimaya(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfInsuranceBankFutureHimayaViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfInsuranceBankFutureHimayaViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetInsuranceBankFutureHimaya(response: HttpResponseBase): Observable<B3GResponseOfListOfInsuranceBankFutureHimayaViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfInsuranceBankFutureHimayaViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfInsuranceBankFutureHimayaViewModel>(<any>null);
    }
}

export interface IOperatorServiceProxy {
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getListOperator(authorization: string | null | undefined): Observable<B3GResponseOfListOfOperatorViewModel>;
}

@Injectable()
export class OperatorServiceProxy implements IOperatorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

   /* constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://www.e-cihbank.ma:90/";
    }*/

    constructor(
        @Inject(HttpClient) http: HttpClient,
        @Inject('API_BASE_URL') private apiBaseUrl: string
      ) {
        this.http = http;
        this.baseUrl = apiBaseUrl;
      }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getListOperator(authorization: string | null | undefined): Observable<B3GResponseOfListOfOperatorViewModel> {
        let url_ = this.baseUrl + "/api/Operator/GetListOperator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListOperator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListOperator(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfOperatorViewModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfOperatorViewModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetListOperator(response: HttpResponseBase): Observable<B3GResponseOfListOfOperatorViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfOperatorViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfOperatorViewModel>(<any>null);
    }
}

export interface IProfessionServiceProxy {
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAll(authorization: string | null | undefined): Observable<B3GResponseOfListOfProfessionalDto>;
}

@Injectable()
export class ProfessionServiceProxy implements IProfessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /* constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://www.e-cihbank.ma:90/";
    } */

    constructor(
        @Inject(HttpClient) http: HttpClient,
        @Inject('API_BASE_URL') private apiBaseUrl: string
      ) {
        this.http = http;
        this.baseUrl = apiBaseUrl;
      }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getAll(authorization: string | null | undefined): Observable<B3GResponseOfListOfProfessionalDto> {
        let url_ = this.baseUrl + "/api/Profession/GetListProfessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfProfessionalDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfProfessionalDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<B3GResponseOfListOfProfessionalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfProfessionalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfProfessionalDto>(<any>null);
    }
}

export interface IProspectServiceProxy {
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    callBack(authorization: string | null | undefined): Observable<B3GResponseOfInt32>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    addProspect(model: ProspectFirstStep, authorization: string | null | undefined): Observable<B3GResponseOfInt32>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    confirmEmail(prospectToken: string, authorization: string | null | undefined): Observable<B3GResponseOfProspectInfoDto>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    confirmGSM(confirmGSMInput: ConfirmGSMInput, authorization: string | null | undefined): Observable<B3GResponseOfProspectInfoDto>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    completeProspect(completeProspectDto: CompleteProspectDto, authorization: string | null | undefined): Observable<B3GResponseOfInt32>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    takeAppointement(takeAppointmentDto: TakeAppointmentDto, authorization: string | null | undefined): Observable<B3GResponseOfInt32>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    finalizeProcess(mobileFinalizeProcess: MobileFinalizeProcess, authorization: string | null | undefined): Observable<B3GResponseOfInt32>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getFolderProgress(authorization: string | null | undefined): Observable<B3GResponseOfFolderProgressOutput>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getProspectInfo(authorization: string | null | undefined): Observable<B3GResponseOfProspectInfoDto>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    uploadBadFiles(badFilesInput: BadFilesInput, authorization: string | null | undefined): Observable<B3GResponseOfString>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mobileAddProspect(prospectFirstStep: ProspectFirstStep, authorization: string | null | undefined): Observable<B3GResponseOfString>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mobileCompleteProspect(completeProspectDto: MobileCompleteProspectDto, authorization: string | null | undefined): Observable<B3GResponseOfString>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mobileConfirmEmail(token: TokenInput, authorization: string | null | undefined): Observable<B3GResponseOfString>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    resendMail(token: TokenInput, authorization: string | null | undefined): Observable<B3GResponseOfString>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    checkEmailOtp(otp: OtpInput, authorization: string | null | undefined): Observable<B3GResponseOfString>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mobileConfirmGSM(confirmGSMInput: MobileConfirmGSMInput, authorization: string | null | undefined): Observable<B3GResponseOfString>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    resendOtp(prospectToken: string, authorization: string | null | undefined): Observable<B3GResponseOfString>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mobileFinalizeProcess(mobileFinalizeProcess: MobileFinalizeProcess, authorization: string | null | undefined): Observable<B3GResponseOfInt32>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    changeMail(input: ChangeEmail, authorization: string | null | undefined): Observable<B3GResponseOfInt32>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mobileTheRestOfInfo(infoProspect: InfoProspect, authorization: string | null | undefined): Observable<B3GResponseOfListOfProspectOfferDto>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    faceMatching(file: FileInput, authorization: string | null | undefined): Observable<B3GResponseOfResultMatchingFace>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    faceMatchingGemadec(model: FaceMatchingDto, authorization: string | null | undefined): Observable<B3GResponseOfResultMatchingFace>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    cropFace(file: FileInput, authorization: string | null | undefined): Observable<B3GResponseOfCroppingFaceCIN>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    setOffers(offer: OffersInput, authorization: string | null | undefined): Observable<B3GResponseOfString>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getCollSocio(authorization: string | null | undefined): Observable<B3GResponseOfListOfSocioProfessionnell>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getProfession(id: string, authorization: string | null | undefined): Observable<B3GResponseOfListOfProfessionOutput>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getMediaFileProspect(authorization: string | null | undefined): Observable<B3GResponseOfListOfProspectMediContent>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    infoOcrMatching(inf: StatisOCR, authorization: string | null | undefined): Observable<B3GResponseOfString>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    setProductTypeForMre(productType: string, authorization: string | null | undefined): Observable<B3GResponseOfBoolean>;
}

@Injectable()
export class ProspectServiceProxy implements IProspectServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /* constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://www.e-cihbank.ma:90/";
    } */

    constructor(
        @Inject(HttpClient) http: HttpClient,
        @Inject('API_BASE_URL') private apiBaseUrl: string
      ) {
        this.http = http;
        this.baseUrl = apiBaseUrl;
      }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    callBack(authorization: string | null | undefined): Observable<B3GResponseOfInt32> {
        let url_ = this.baseUrl + "/api/Prospect/CallBack";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCallBack(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCallBack(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfInt32>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfInt32>><any>_observableThrow(response_);
        }));
    }

    protected processCallBack(response: HttpResponseBase): Observable<B3GResponseOfInt32> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfInt32.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfInt32>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    addProspect(model: ProspectFirstStep, authorization: string | null | undefined): Observable<B3GResponseOfInt32> {
        let url_ = this.baseUrl + "/api/Prospect/AddProspect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProspect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProspect(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfInt32>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfInt32>><any>_observableThrow(response_);
        }));
    }

    protected processAddProspect(response: HttpResponseBase): Observable<B3GResponseOfInt32> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfInt32.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfInt32>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    confirmEmail(prospectToken: string, authorization: string | null | undefined): Observable<B3GResponseOfProspectInfoDto> {
        let url_ = this.baseUrl + "/api/Prospect/ConfirmEmail?";
        if (prospectToken === undefined || prospectToken === null)
            throw new Error("The parameter 'prospectToken' must be defined and cannot be null.");
        else
            url_ += "prospectToken=" + encodeURIComponent("" + prospectToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfProspectInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfProspectInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<B3GResponseOfProspectInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfProspectInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfProspectInfoDto>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    confirmGSM(confirmGSMInput: ConfirmGSMInput, authorization: string | null | undefined): Observable<B3GResponseOfProspectInfoDto> {
        let url_ = this.baseUrl + "/api/Prospect/ConfirmGSM";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(confirmGSMInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmGSM(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmGSM(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfProspectInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfProspectInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmGSM(response: HttpResponseBase): Observable<B3GResponseOfProspectInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfProspectInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfProspectInfoDto>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    completeProspect(completeProspectDto: CompleteProspectDto, authorization: string | null | undefined): Observable<B3GResponseOfInt32> {
        let url_ = this.baseUrl + "/api/Prospect/CompleteProspect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(completeProspectDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteProspect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteProspect(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfInt32>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfInt32>><any>_observableThrow(response_);
        }));
    }

    protected processCompleteProspect(response: HttpResponseBase): Observable<B3GResponseOfInt32> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfInt32.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfInt32>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    takeAppointement(takeAppointmentDto: TakeAppointmentDto, authorization: string | null | undefined): Observable<B3GResponseOfInt32> {
        let url_ = this.baseUrl + "/api/Prospect/TakeAppointement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(takeAppointmentDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTakeAppointement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTakeAppointement(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfInt32>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfInt32>><any>_observableThrow(response_);
        }));
    }

    protected processTakeAppointement(response: HttpResponseBase): Observable<B3GResponseOfInt32> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfInt32.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfInt32>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    finalizeProcess(mobileFinalizeProcess: MobileFinalizeProcess, authorization: string | null | undefined): Observable<B3GResponseOfInt32> {
        let url_ = this.baseUrl + "/api/Prospect/FinalizeProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mobileFinalizeProcess);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeProcess(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfInt32>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfInt32>><any>_observableThrow(response_);
        }));
    }

    protected processFinalizeProcess(response: HttpResponseBase): Observable<B3GResponseOfInt32> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfInt32.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfInt32>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getFolderProgress(authorization: string | null | undefined): Observable<B3GResponseOfFolderProgressOutput> {
        let url_ = this.baseUrl + "/api/Prospect/GetFolderProgress";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFolderProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFolderProgress(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfFolderProgressOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfFolderProgressOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFolderProgress(response: HttpResponseBase): Observable<B3GResponseOfFolderProgressOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfFolderProgressOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfFolderProgressOutput>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getProspectInfo(authorization: string | null | undefined): Observable<B3GResponseOfProspectInfoDto> {
        let url_ = this.baseUrl + "/api/Prospect/GetProspectInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProspectInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProspectInfo(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfProspectInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfProspectInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProspectInfo(response: HttpResponseBase): Observable<B3GResponseOfProspectInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfProspectInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfProspectInfoDto>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    uploadBadFiles(badFilesInput: BadFilesInput, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/Prospect/UploadBadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(badFilesInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBadFiles(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processUploadBadFiles(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mobileAddProspect(prospectFirstStep: ProspectFirstStep, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/Prospect/MobileAddProspect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(prospectFirstStep);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileAddProspect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileAddProspect(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processMobileAddProspect(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mobileCompleteProspect(completeProspectDto: MobileCompleteProspectDto, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/Prospect/MobileCompleteProspect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(completeProspectDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileCompleteProspect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileCompleteProspect(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processMobileCompleteProspect(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mobileConfirmEmail(token: TokenInput, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/Prospect/MobileConfirmEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileConfirmEmail(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processMobileConfirmEmail(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    resendMail(token: TokenInput, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/Prospect/ResendMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendMail(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processResendMail(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    checkEmailOtp(otp: OtpInput, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/Prospect/CheckEmailOtp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(otp);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckEmailOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEmailOtp(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processCheckEmailOtp(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mobileConfirmGSM(confirmGSMInput: MobileConfirmGSMInput, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/Prospect/MobileConfirmGSM";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(confirmGSMInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileConfirmGSM(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileConfirmGSM(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processMobileConfirmGSM(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    resendOtp(prospectToken: string, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/Prospect/ResendOtp?";
        if (prospectToken === undefined || prospectToken === null)
            throw new Error("The parameter 'prospectToken' must be defined and cannot be null.");
        else
            url_ += "prospectToken=" + encodeURIComponent("" + prospectToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendOtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendOtp(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processResendOtp(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mobileFinalizeProcess(mobileFinalizeProcess: MobileFinalizeProcess, authorization: string | null | undefined): Observable<B3GResponseOfInt32> {
        let url_ = this.baseUrl + "/api/Prospect/MobileFinalizeProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mobileFinalizeProcess);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileFinalizeProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileFinalizeProcess(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfInt32>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfInt32>><any>_observableThrow(response_);
        }));
    }

    protected processMobileFinalizeProcess(response: HttpResponseBase): Observable<B3GResponseOfInt32> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfInt32.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfInt32>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    changeMail(input: ChangeEmail, authorization: string | null | undefined): Observable<B3GResponseOfInt32> {
        let url_ = this.baseUrl + "/api/Prospect/ChangeMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeMail(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfInt32>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfInt32>><any>_observableThrow(response_);
        }));
    }

    protected processChangeMail(response: HttpResponseBase): Observable<B3GResponseOfInt32> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfInt32.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfInt32>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    mobileTheRestOfInfo(infoProspect: InfoProspect, authorization: string | null | undefined): Observable<B3GResponseOfListOfProspectOfferDto> {
        let url_ = this.baseUrl + "/api/Prospect/MobileTheRestOfInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(infoProspect);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMobileTheRestOfInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMobileTheRestOfInfo(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfProspectOfferDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfProspectOfferDto>><any>_observableThrow(response_);
        }));
    }

    protected processMobileTheRestOfInfo(response: HttpResponseBase): Observable<B3GResponseOfListOfProspectOfferDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfProspectOfferDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfProspectOfferDto>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    faceMatching(file: FileInput, authorization: string | null | undefined): Observable<B3GResponseOfResultMatchingFace> {
        let url_ = this.baseUrl + "/api/Prospect/FaceMatching";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFaceMatching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFaceMatching(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfResultMatchingFace>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfResultMatchingFace>><any>_observableThrow(response_);
        }));
    }

    protected processFaceMatching(response: HttpResponseBase): Observable<B3GResponseOfResultMatchingFace> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfResultMatchingFace.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfResultMatchingFace>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    faceMatchingGemadec(model: FaceMatchingDto, authorization: string | null | undefined): Observable<B3GResponseOfResultMatchingFace> {
        let url_ = this.baseUrl + "/api/Prospect/Matching/Gemadec";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFaceMatchingGemadec(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFaceMatchingGemadec(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfResultMatchingFace>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfResultMatchingFace>><any>_observableThrow(response_);
        }));
    }

    protected processFaceMatchingGemadec(response: HttpResponseBase): Observable<B3GResponseOfResultMatchingFace> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfResultMatchingFace.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfResultMatchingFace>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    cropFace(file: FileInput, authorization: string | null | undefined): Observable<B3GResponseOfCroppingFaceCIN> {
        let url_ = this.baseUrl + "/api/Prospect/CropFace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCropFace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCropFace(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfCroppingFaceCIN>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfCroppingFaceCIN>><any>_observableThrow(response_);
        }));
    }

    protected processCropFace(response: HttpResponseBase): Observable<B3GResponseOfCroppingFaceCIN> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfCroppingFaceCIN.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfCroppingFaceCIN>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    setOffers(offer: OffersInput, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/Prospect/setOffers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(offer);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetOffers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOffers(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processSetOffers(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getCollSocio(authorization: string | null | undefined): Observable<B3GResponseOfListOfSocioProfessionnell> {
        let url_ = this.baseUrl + "/api/Prospect/getcollSocio";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCollSocio(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCollSocio(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfSocioProfessionnell>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfSocioProfessionnell>><any>_observableThrow(response_);
        }));
    }

    protected processGetCollSocio(response: HttpResponseBase): Observable<B3GResponseOfListOfSocioProfessionnell> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfSocioProfessionnell.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfSocioProfessionnell>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getProfession(id: string, authorization: string | null | undefined): Observable<B3GResponseOfListOfProfessionOutput> {
        let url_ = this.baseUrl + "/api/Prospect/GetProfession?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfession(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfProfessionOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfProfessionOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfession(response: HttpResponseBase): Observable<B3GResponseOfListOfProfessionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfProfessionOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfProfessionOutput>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getMediaFileProspect(authorization: string | null | undefined): Observable<B3GResponseOfListOfProspectMediContent> {
        let url_ = this.baseUrl + "/api/Prospect/getMediaFilesProspect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMediaFileProspect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMediaFileProspect(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfProspectMediContent>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfProspectMediContent>><any>_observableThrow(response_);
        }));
    }

    protected processGetMediaFileProspect(response: HttpResponseBase): Observable<B3GResponseOfListOfProspectMediContent> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfProspectMediContent.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfProspectMediContent>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    infoOcrMatching(inf: StatisOCR, authorization: string | null | undefined): Observable<B3GResponseOfString> {
        let url_ = this.baseUrl + "/api/Prospect/infoocrMatching";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inf);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfoOcrMatching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfoOcrMatching(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfString>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfString>><any>_observableThrow(response_);
        }));
    }

    protected processInfoOcrMatching(response: HttpResponseBase): Observable<B3GResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfString.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfString>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    setProductTypeForMre(productType: string, authorization: string | null | undefined): Observable<B3GResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/Prospect/ProductType?";
        if (productType === undefined || productType === null)
            throw new Error("The parameter 'productType' must be defined and cannot be null.");
        else
            url_ += "productType=" + encodeURIComponent("" + productType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetProductTypeForMre(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetProductTypeForMre(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfBoolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfBoolean>><any>_observableThrow(response_);
        }));
    }

    protected processSetProductTypeForMre(response: HttpResponseBase): Observable<B3GResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfBoolean>(<any>null);
    }
}

export interface IProspectProductServiceProxy {
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getProducts(idOffer: string, authorization: string | null | undefined): Observable<B3GResponseOfListOfProspectProductDto>;
    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getOffer(idOffer: string, authorization: string | null | undefined): Observable<B3GResponseOfOfferDto>;
}

@Injectable()
export class ProspectProductServiceProxy implements IProspectProductServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /* constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://www.e-cihbank.ma:90/";
    } */

    constructor(
        @Inject(HttpClient) http: HttpClient,
        @Inject('API_BASE_URL') private apiBaseUrl: string
      ) {
        this.http = http;
        this.baseUrl = apiBaseUrl;
      }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getProducts(idOffer: string, authorization: string | null | undefined): Observable<B3GResponseOfListOfProspectProductDto> {
        let url_ = this.baseUrl + "/api/ProspectProduct/GetProducts?";
        if (idOffer === undefined || idOffer === null)
            throw new Error("The parameter 'idOffer' must be defined and cannot be null.");
        else
            url_ += "idOffer=" + encodeURIComponent("" + idOffer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProducts(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfListOfProspectProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfListOfProspectProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProducts(response: HttpResponseBase): Observable<B3GResponseOfListOfProspectProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfListOfProspectProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfListOfProspectProductDto>(<any>null);
    }

    /**
     * @param authorization (optional) My Authorization field
     * @return OK
     */
    getOffer(idOffer: string, authorization: string | null | undefined): Observable<B3GResponseOfOfferDto> {
        let url_ = this.baseUrl + "/api/ProspectProduct/GetOffer?";
        if (idOffer === undefined || idOffer === null)
            throw new Error("The parameter 'idOffer' must be defined and cannot be null.");
        else
            url_ += "idOffer=" + encodeURIComponent("" + idOffer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Authorization": authorization !== undefined && authorization !== null ? "" + authorization : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOffer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOffer(<any>response_);
                } catch (e) {
                    return <Observable<B3GResponseOfOfferDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<B3GResponseOfOfferDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOffer(response: HttpResponseBase): Observable<B3GResponseOfOfferDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B3GResponseOfOfferDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<B3GResponseOfOfferDto>(<any>null);
    }
}

export class B3GResponseOfListOfAgenceMapOutputDto implements IB3GResponseOfListOfAgenceMapOutputDto {
    result?: AgenceMapOutputDto[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfAgenceMapOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(AgenceMapOutputDto.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfAgenceMapOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfAgenceMapOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfAgenceMapOutputDto {
    result?: AgenceMapOutputDto[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class AgenceMapOutputDto implements IAgenceMapOutputDto {
    codeAgence?: string | undefined;
    ville?: string | undefined;
    agenceName?: string | undefined;
    adresse?: string | undefined;
    numeroMobile?: string | undefined;
    numeroFixe?: string | undefined;
    flagOuverture?: string | undefined;
    longitude?: number | undefined;
    latitude?: number | undefined;
    status?: string | undefined;
    type?: string | undefined;
    horaireHiver?: string | undefined;
    horaireEte?: string | undefined;
    ouvertureSamedi?: string | undefined;
    ouvertureDimanche?: string | undefined;

    constructor(data?: IAgenceMapOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeAgence = _data["CodeAgence"];
            this.ville = _data["ville"];
            this.agenceName = _data["AgenceName"];
            this.adresse = _data["Adresse"];
            this.numeroMobile = _data["NumeroMobile"];
            this.numeroFixe = _data["NumeroFixe"];
            this.flagOuverture = _data["FlagOuverture"];
            this.longitude = _data["Longitude"];
            this.latitude = _data["Latitude"];
            this.status = _data["Status"];
            this.type = _data["Type"];
            this.horaireHiver = _data["HoraireHiver"];
            this.horaireEte = _data["HoraireEte"];
            this.ouvertureSamedi = _data["OuvertureSamedi"];
            this.ouvertureDimanche = _data["OuvertureDimanche"];
        }
    }

    static fromJS(data: any): AgenceMapOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgenceMapOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CodeAgence"] = this.codeAgence;
        data["ville"] = this.ville;
        data["AgenceName"] = this.agenceName;
        data["Adresse"] = this.adresse;
        data["NumeroMobile"] = this.numeroMobile;
        data["NumeroFixe"] = this.numeroFixe;
        data["FlagOuverture"] = this.flagOuverture;
        data["Longitude"] = this.longitude;
        data["Latitude"] = this.latitude;
        data["Status"] = this.status;
        data["Type"] = this.type;
        data["HoraireHiver"] = this.horaireHiver;
        data["HoraireEte"] = this.horaireEte;
        data["OuvertureSamedi"] = this.ouvertureSamedi;
        data["OuvertureDimanche"] = this.ouvertureDimanche;
        return data; 
    }
}

export interface IAgenceMapOutputDto {
    codeAgence?: string | undefined;
    ville?: string | undefined;
    agenceName?: string | undefined;
    adresse?: string | undefined;
    numeroMobile?: string | undefined;
    numeroFixe?: string | undefined;
    flagOuverture?: string | undefined;
    longitude?: number | undefined;
    latitude?: number | undefined;
    status?: string | undefined;
    type?: string | undefined;
    horaireHiver?: string | undefined;
    horaireEte?: string | undefined;
    ouvertureSamedi?: string | undefined;
    ouvertureDimanche?: string | undefined;
}

export class Validation implements IValidation {
    attribute?: string | undefined;
    statusCode?: string | undefined;

    constructor(data?: IValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attribute = _data["Attribute"];
            this.statusCode = _data["StatusCode"];
        }
    }

    static fromJS(data: any): Validation {
        data = typeof data === 'object' ? data : {};
        let result = new Validation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Attribute"] = this.attribute;
        data["StatusCode"] = this.statusCode;
        return data; 
    }
}

export interface IValidation {
    attribute?: string | undefined;
    statusCode?: string | undefined;
}

export class B3GResponseOfListOfCityOutputModel implements IB3GResponseOfListOfCityOutputModel {
    result?: CityOutputModel[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfCityOutputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(CityOutputModel.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfCityOutputModel {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfCityOutputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfCityOutputModel {
    result?: CityOutputModel[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class CityOutputModel implements ICityOutputModel {
    name?: string | undefined;

    constructor(data?: ICityOutputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): CityOutputModel {
        data = typeof data === 'object' ? data : {};
        let result = new CityOutputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        return data; 
    }
}

export interface ICityOutputModel {
    name?: string | undefined;
}

export class GetAgencyMapInputModel implements IGetAgencyMapInputModel {
    city?: string | undefined;
    code?: string | undefined;

    constructor(data?: IGetAgencyMapInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["City"];
            this.code = _data["Code"];
        }
    }

    static fromJS(data: any): GetAgencyMapInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgencyMapInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["City"] = this.city;
        data["Code"] = this.code;
        return data; 
    }
}

export interface IGetAgencyMapInputModel {
    city?: string | undefined;
    code?: string | undefined;
}

export class B3GResponseOfAgenceMapOutputDto implements IB3GResponseOfAgenceMapOutputDto {
    result?: AgenceMapOutputDto | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfAgenceMapOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"] ? AgenceMapOutputDto.fromJS(_data["Result"]) : <any>undefined;
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfAgenceMapOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfAgenceMapOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfAgenceMapOutputDto {
    result?: AgenceMapOutputDto | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class LoginInput implements ILoginInput {
    userName?: string | undefined;
    password?: string | undefined;
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    deviceInfo?: string | undefined;
    pushId?: string | undefined;
    canal?: string | undefined;

    constructor(data?: ILoginInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["UserName"];
            this.password = _data["Password"];
            this.clientId = _data["ClientId"];
            this.clientSecret = _data["ClientSecret"];
            this.deviceInfo = _data["DeviceInfo"];
            this.pushId = _data["PushId"];
            this.canal = _data["Canal"];
        }
    }

    static fromJS(data: any): LoginInput {
        data = typeof data === 'object' ? data : {};
        let result = new LoginInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserName"] = this.userName;
        data["Password"] = this.password;
        data["ClientId"] = this.clientId;
        data["ClientSecret"] = this.clientSecret;
        data["DeviceInfo"] = this.deviceInfo;
        data["PushId"] = this.pushId;
        data["Canal"] = this.canal;
        return data; 
    }
}

export interface ILoginInput {
    userName?: string | undefined;
    password?: string | undefined;
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    deviceInfo?: string | undefined;
    pushId?: string | undefined;
    canal?: string | undefined;
}

export class B3GResponseOfLoginOutput implements IB3GResponseOfLoginOutput {
    result?: LoginOutput | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfLoginOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"] ? LoginOutput.fromJS(_data["Result"]) : <any>undefined;
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfLoginOutput {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfLoginOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfLoginOutput {
    result?: LoginOutput | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class LoginOutput implements ILoginOutput {
    sessionId?: string | undefined;

    constructor(data?: ILoginOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["SessionId"];
        }
    }

    static fromJS(data: any): LoginOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LoginOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SessionId"] = this.sessionId;
        return data; 
    }
}

export interface ILoginOutput {
    sessionId?: string | undefined;
}

export class LoginEERInput implements ILoginEERInput {
    userName?: string | undefined;
    password?: string | undefined;
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    canal?: string | undefined;

    constructor(data?: ILoginEERInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["UserName"];
            this.password = _data["Password"];
            this.clientId = _data["ClientId"];
            this.clientSecret = _data["ClientSecret"];
            this.canal = _data["Canal"];
        }
    }

    static fromJS(data: any): LoginEERInput {
        data = typeof data === 'object' ? data : {};
        let result = new LoginEERInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserName"] = this.userName;
        data["Password"] = this.password;
        data["ClientId"] = this.clientId;
        data["ClientSecret"] = this.clientSecret;
        data["Canal"] = this.canal;
        return data; 
    }
}

export interface ILoginEERInput {
    userName?: string | undefined;
    password?: string | undefined;
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    canal?: string | undefined;
}

export class LogoutInput implements ILogoutInput {
    sessionId?: string | undefined;

    constructor(data?: ILogoutInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["SessionId"];
        }
    }

    static fromJS(data: any): LogoutInput {
        data = typeof data === 'object' ? data : {};
        let result = new LogoutInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SessionId"] = this.sessionId;
        return data; 
    }
}

export interface ILogoutInput {
    sessionId?: string | undefined;
}

export class B3GResponseOfLogoutOutput implements IB3GResponseOfLogoutOutput {
    result?: LogoutOutput | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfLogoutOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"] ? LogoutOutput.fromJS(_data["Result"]) : <any>undefined;
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfLogoutOutput {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfLogoutOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfLogoutOutput {
    result?: LogoutOutput | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class LogoutOutput implements ILogoutOutput {
    success?: boolean | undefined;

    constructor(data?: ILogoutOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
        }
    }

    static fromJS(data: any): LogoutOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LogoutOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Success"] = this.success;
        return data; 
    }
}

export interface ILogoutOutput {
    success?: boolean | undefined;
}

export class B3GResponseOfListOfCountryDto implements IB3GResponseOfListOfCountryDto {
    result?: CountryDto[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfCountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(CountryDto.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfCountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfCountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfCountryDto {
    result?: CountryDto[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class CountryDto implements ICountryDto {
    id?: string | undefined;
    rank?: number | undefined;
    libelleFr?: string | undefined;
    code?: string | undefined;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.rank = _data["Rank"];
            this.libelleFr = _data["LibelleFr"];
            this.code = _data["Code"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Rank"] = this.rank;
        data["LibelleFr"] = this.libelleFr;
        data["Code"] = this.code;
        return data; 
    }
}

export interface ICountryDto {
    id?: string | undefined;
    rank?: number | undefined;
    libelleFr?: string | undefined;
    code?: string | undefined;
}

export class B3GResponseOfListOfString implements IB3GResponseOfListOfString {
    result?: string[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(item);
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfString {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item);
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfString {
    result?: string[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class B3GResponseOfListOfSecteurActivite implements IB3GResponseOfListOfSecteurActivite {
    result?: SecteurActivite[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfSecteurActivite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(SecteurActivite.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfSecteurActivite {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfSecteurActivite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfSecteurActivite {
    result?: SecteurActivite[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class SecteurActivite implements ISecteurActivite {
    id?: number | undefined;
    seteurActivite?: string | undefined;
    codeNova?: string | undefined;

    constructor(data?: ISecteurActivite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.seteurActivite = _data["seteurActivite"];
            this.codeNova = _data["codeNova"];
        }
    }

    static fromJS(data: any): SecteurActivite {
        data = typeof data === 'object' ? data : {};
        let result = new SecteurActivite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["seteurActivite"] = this.seteurActivite;
        data["codeNova"] = this.codeNova;
        return data; 
    }
}

export interface ISecteurActivite {
    id?: number | undefined;
    seteurActivite?: string | undefined;
    codeNova?: string | undefined;
}

export class B3GResponseOfListOfMotif implements IB3GResponseOfListOfMotif {
    result?: Motif[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfMotif) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(Motif.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfMotif {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfMotif();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfMotif {
    result?: Motif[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class Motif implements IMotif {
    id?: number | undefined;
    motif1?: string | undefined;

    constructor(data?: IMotif) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.motif1 = _data["motif1"];
        }
    }

    static fromJS(data: any): Motif {
        data = typeof data === 'object' ? data : {};
        let result = new Motif();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["motif1"] = this.motif1;
        return data; 
    }
}

export interface IMotif {
    id?: number | undefined;
    motif1?: string | undefined;
}

export class B3GResponseOfListOfOrigineDeFonds implements IB3GResponseOfListOfOrigineDeFonds {
    result?: OrigineDeFonds[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfOrigineDeFonds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(OrigineDeFonds.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfOrigineDeFonds {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfOrigineDeFonds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfOrigineDeFonds {
    result?: OrigineDeFonds[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class OrigineDeFonds implements IOrigineDeFonds {
    id?: number | undefined;
    origineFonds?: string | undefined;
    codeNova?: string | undefined;

    constructor(data?: IOrigineDeFonds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.origineFonds = _data["origineFonds"];
            this.codeNova = _data["codeNova"];
        }
    }

    static fromJS(data: any): OrigineDeFonds {
        data = typeof data === 'object' ? data : {};
        let result = new OrigineDeFonds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["origineFonds"] = this.origineFonds;
        data["codeNova"] = this.codeNova;
        return data; 
    }
}

export interface IOrigineDeFonds {
    id?: number | undefined;
    origineFonds?: string | undefined;
    codeNova?: string | undefined;
}

export class B3GResponseOfListOfSituationFamilial implements IB3GResponseOfListOfSituationFamilial {
    result?: SituationFamilial[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfSituationFamilial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(SituationFamilial.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfSituationFamilial {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfSituationFamilial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfSituationFamilial {
    result?: SituationFamilial[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class SituationFamilial implements ISituationFamilial {
    id?: number | undefined;
    situationFamilial1?: string | undefined;
    codeNova?: string | undefined;

    constructor(data?: ISituationFamilial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.situationFamilial1 = _data["situationFamilial1"];
            this.codeNova = _data["codeNova"];
        }
    }

    static fromJS(data: any): SituationFamilial {
        data = typeof data === 'object' ? data : {};
        let result = new SituationFamilial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["situationFamilial1"] = this.situationFamilial1;
        data["codeNova"] = this.codeNova;
        return data; 
    }
}

export interface ISituationFamilial {
    id?: number | undefined;
    situationFamilial1?: string | undefined;
    codeNova?: string | undefined;
}

export class B3GResponseOfListOfMotivationOuverture implements IB3GResponseOfListOfMotivationOuverture {
    result?: MotivationOuverture[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfMotivationOuverture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(MotivationOuverture.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfMotivationOuverture {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfMotivationOuverture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfMotivationOuverture {
    result?: MotivationOuverture[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class MotivationOuverture implements IMotivationOuverture {
    id?: number | undefined;
    label?: string | undefined;

    constructor(data?: IMotivationOuverture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): MotivationOuverture {
        data = typeof data === 'object' ? data : {};
        let result = new MotivationOuverture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Label"] = this.label;
        return data; 
    }
}

export interface IMotivationOuverture {
    id?: number | undefined;
    label?: string | undefined;
}

export class B3GResponseOfListOfApointementDTO implements IB3GResponseOfListOfApointementDTO {
    result?: ApointementDTO[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfApointementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(ApointementDTO.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfApointementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfApointementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfApointementDTO {
    result?: ApointementDTO[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class ApointementDTO implements IApointementDTO {
    ordrejour?: string | undefined;
    jour?: string | undefined;
    listAppoientement?: AppointementTime[] | undefined;

    constructor(data?: IApointementDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordrejour = _data["ordrejour"];
            this.jour = _data["jour"];
            if (Array.isArray(_data["listAppoientement"])) {
                this.listAppoientement = [] as any;
                for (let item of _data["listAppoientement"])
                    this.listAppoientement!.push(AppointementTime.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApointementDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApointementDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordrejour"] = this.ordrejour;
        data["jour"] = this.jour;
        if (Array.isArray(this.listAppoientement)) {
            data["listAppoientement"] = [];
            for (let item of this.listAppoientement)
                data["listAppoientement"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IApointementDTO {
    ordrejour?: string | undefined;
    jour?: string | undefined;
    listAppoientement?: AppointementTime[] | undefined;
}

export class AppointementTime implements IAppointementTime {
    id?: number | undefined;
    libelle?: string | undefined;
    quota?: number | undefined;
    quotaMax?: number | undefined;
    incrementDenied?: boolean | undefined;
    dateMax?: string | undefined;
    quotaDayPlus1?: number | undefined;
    quotaDayPlus2?: number | undefined;
    incrementDeniedDayPlus1?: boolean | undefined;
    incrementDeniedDayPlus2?: boolean | undefined;

    constructor(data?: IAppointementTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.libelle = _data["libelle"];
            this.quota = _data["quota"];
            this.quotaMax = _data["quotaMax"];
            this.incrementDenied = _data["IncrementDenied"];
            this.dateMax = _data["dateMax"];
            this.quotaDayPlus1 = _data["quotaDayPlus1"];
            this.quotaDayPlus2 = _data["quotaDayPlus2"];
            this.incrementDeniedDayPlus1 = _data["IncrementDeniedDayPlus1"];
            this.incrementDeniedDayPlus2 = _data["IncrementDeniedDayPlus2"];
        }
    }

    static fromJS(data: any): AppointementTime {
        data = typeof data === 'object' ? data : {};
        let result = new AppointementTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["libelle"] = this.libelle;
        data["quota"] = this.quota;
        data["quotaMax"] = this.quotaMax;
        data["IncrementDenied"] = this.incrementDenied;
        data["dateMax"] = this.dateMax;
        data["quotaDayPlus1"] = this.quotaDayPlus1;
        data["quotaDayPlus2"] = this.quotaDayPlus2;
        data["IncrementDeniedDayPlus1"] = this.incrementDeniedDayPlus1;
        data["IncrementDeniedDayPlus2"] = this.incrementDeniedDayPlus2;
        return data; 
    }
}

export interface IAppointementTime {
    id?: number | undefined;
    libelle?: string | undefined;
    quota?: number | undefined;
    quotaMax?: number | undefined;
    incrementDenied?: boolean | undefined;
    dateMax?: string | undefined;
    quotaDayPlus1?: number | undefined;
    quotaDayPlus2?: number | undefined;
    incrementDeniedDayPlus1?: boolean | undefined;
    incrementDeniedDayPlus2?: boolean | undefined;
}

export class CheckUser implements ICheckUser {
    customerId?: string | undefined;
    phoneNumber?: string | undefined;
    operator?: string | undefined;

    constructor(data?: ICheckUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["CustomerId"];
            this.phoneNumber = _data["PhoneNumber"];
            this.operator = _data["Operator"];
        }
    }

    static fromJS(data: any): CheckUser {
        data = typeof data === 'object' ? data : {};
        let result = new CheckUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerId"] = this.customerId;
        data["PhoneNumber"] = this.phoneNumber;
        data["Operator"] = this.operator;
        return data; 
    }
}

export interface ICheckUser {
    customerId?: string | undefined;
    phoneNumber?: string | undefined;
    operator?: string | undefined;
}

export class B3GResponseOfActivateStepOneOutputModel implements IB3GResponseOfActivateStepOneOutputModel {
    result?: ActivateStepOneOutputModel | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfActivateStepOneOutputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"] ? ActivateStepOneOutputModel.fromJS(_data["Result"]) : <any>undefined;
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfActivateStepOneOutputModel {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfActivateStepOneOutputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfActivateStepOneOutputModel {
    result?: ActivateStepOneOutputModel | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class ActivateStepOneOutputModel implements IActivateStepOneOutputModel {
    transactionId?: string | undefined;

    constructor(data?: IActivateStepOneOutputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["TransactionId"];
        }
    }

    static fromJS(data: any): ActivateStepOneOutputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateStepOneOutputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TransactionId"] = this.transactionId;
        return data; 
    }
}

export interface IActivateStepOneOutputModel {
    transactionId?: string | undefined;
}

export class Otp implements IOtp {
    value?: string | undefined;
    customerId?: string | undefined;
    phone?: string | undefined;

    constructor(data?: IOtp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["Value"];
            this.customerId = _data["CustomerId"];
            this.phone = _data["Phone"];
        }
    }

    static fromJS(data: any): Otp {
        data = typeof data === 'object' ? data : {};
        let result = new Otp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Value"] = this.value;
        data["CustomerId"] = this.customerId;
        data["Phone"] = this.phone;
        return data; 
    }
}

export interface IOtp {
    value?: string | undefined;
    customerId?: string | undefined;
    phone?: string | undefined;
}

export class B3GResponseOfActivationStepTwoOutput implements IB3GResponseOfActivationStepTwoOutput {
    result?: ActivationStepTwoOutput | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfActivationStepTwoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"] ? ActivationStepTwoOutput.fromJS(_data["Result"]) : <any>undefined;
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfActivationStepTwoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfActivationStepTwoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfActivationStepTwoOutput {
    result?: ActivationStepTwoOutput | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class ActivationStepTwoOutput implements IActivationStepTwoOutput {
    questions?: QuestionViewModel[] | undefined;
    transactionId?: string | undefined;

    constructor(data?: IActivationStepTwoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Questions"])) {
                this.questions = [] as any;
                for (let item of _data["Questions"])
                    this.questions!.push(QuestionViewModel.fromJS(item));
            }
            this.transactionId = _data["TransactionId"];
        }
    }

    static fromJS(data: any): ActivationStepTwoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivationStepTwoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.questions)) {
            data["Questions"] = [];
            for (let item of this.questions)
                data["Questions"].push(item.toJSON());
        }
        data["TransactionId"] = this.transactionId;
        return data; 
    }
}

export interface IActivationStepTwoOutput {
    questions?: QuestionViewModel[] | undefined;
    transactionId?: string | undefined;
}

export class QuestionViewModel implements IQuestionViewModel {
    id?: string | undefined;
    value?: string | undefined;

    constructor(data?: IQuestionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): QuestionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Value"] = this.value;
        return data; 
    }
}

export interface IQuestionViewModel {
    id?: string | undefined;
    value?: string | undefined;
}

export class SecretsModel implements ISecretsModel {
    password?: string | undefined;
    question?: string | undefined;
    answer?: string | undefined;

    constructor(data?: ISecretsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["Password"];
            this.question = _data["Question"];
            this.answer = _data["Answer"];
        }
    }

    static fromJS(data: any): SecretsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SecretsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Password"] = this.password;
        data["Question"] = this.question;
        data["Answer"] = this.answer;
        return data; 
    }
}

export interface ISecretsModel {
    password?: string | undefined;
    question?: string | undefined;
    answer?: string | undefined;
}

export class B3GResponseOfActivateStepThreeOutputModel implements IB3GResponseOfActivateStepThreeOutputModel {
    result?: ActivateStepThreeOutputModel | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfActivateStepThreeOutputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"] ? ActivateStepThreeOutputModel.fromJS(_data["Result"]) : <any>undefined;
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfActivateStepThreeOutputModel {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfActivateStepThreeOutputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfActivateStepThreeOutputModel {
    result?: ActivateStepThreeOutputModel | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class ActivateStepThreeOutputModel implements IActivateStepThreeOutputModel {
    status?: string | undefined;

    constructor(data?: IActivateStepThreeOutputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): ActivateStepThreeOutputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateStepThreeOutputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Status"] = this.status;
        return data; 
    }
}

export interface IActivateStepThreeOutputModel {
    status?: string | undefined;
}

export class B3GResponseOfMpoStepOneOutput implements IB3GResponseOfMpoStepOneOutput {
    result?: MpoStepOneOutput | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfMpoStepOneOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"] ? MpoStepOneOutput.fromJS(_data["Result"]) : <any>undefined;
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfMpoStepOneOutput {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfMpoStepOneOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfMpoStepOneOutput {
    result?: MpoStepOneOutput | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class MpoStepOneOutput implements IMpoStepOneOutput {
    transactionId?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IMpoStepOneOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["TransactionId"];
            this.phoneNumber = _data["PhoneNumber"];
        }
    }

    static fromJS(data: any): MpoStepOneOutput {
        data = typeof data === 'object' ? data : {};
        let result = new MpoStepOneOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TransactionId"] = this.transactionId;
        data["PhoneNumber"] = this.phoneNumber;
        return data; 
    }
}

export interface IMpoStepOneOutput {
    transactionId?: string | undefined;
    phoneNumber?: string | undefined;
}

export class B3GResponseOfMpoStepTwoOutput implements IB3GResponseOfMpoStepTwoOutput {
    result?: MpoStepTwoOutput | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfMpoStepTwoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"] ? MpoStepTwoOutput.fromJS(_data["Result"]) : <any>undefined;
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfMpoStepTwoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfMpoStepTwoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfMpoStepTwoOutput {
    result?: MpoStepTwoOutput | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class MpoStepTwoOutput implements IMpoStepTwoOutput {
    transactionId?: string | undefined;
    question?: string | undefined;

    constructor(data?: IMpoStepTwoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["TransactionId"];
            this.question = _data["Question"];
        }
    }

    static fromJS(data: any): MpoStepTwoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new MpoStepTwoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TransactionId"] = this.transactionId;
        data["Question"] = this.question;
        return data; 
    }
}

export interface IMpoStepTwoOutput {
    transactionId?: string | undefined;
    question?: string | undefined;
}

export class CheckAnswer implements ICheckAnswer {
    answer?: string | undefined;
    customerId?: string | undefined;

    constructor(data?: ICheckAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answer = _data["Answer"];
            this.customerId = _data["CustomerId"];
        }
    }

    static fromJS(data: any): CheckAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new CheckAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Answer"] = this.answer;
        data["CustomerId"] = this.customerId;
        return data; 
    }
}

export interface ICheckAnswer {
    answer?: string | undefined;
    customerId?: string | undefined;
}

export class B3GResponseOfString implements IB3GResponseOfString {
    result?: string | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"];
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfString {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result;
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfString {
    result?: string | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class PasswordModel implements IPasswordModel {
    password?: string | undefined;

    constructor(data?: IPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): PasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Password"] = this.password;
        return data; 
    }
}

export interface IPasswordModel {
    password?: string | undefined;
}

export class Answer implements IAnswer {
    value?: string | undefined;

    constructor(data?: IAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): Answer {
        data = typeof data === 'object' ? data : {};
        let result = new Answer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Value"] = this.value;
        return data; 
    }
}

export interface IAnswer {
    value?: string | undefined;
}

export class CustomerData implements ICustomerData {
    customerId?: string | undefined;
    password?: string | undefined;
    question?: string | undefined;
    answer?: string | undefined;
    channel?: string | undefined;
    tierId?: string | undefined;

    constructor(data?: ICustomerData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["CustomerId"];
            this.password = _data["Password"];
            this.question = _data["Question"];
            this.answer = _data["Answer"];
            this.channel = _data["Channel"];
            this.tierId = _data["TierId"];
        }
    }

    static fromJS(data: any): CustomerData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerId"] = this.customerId;
        data["Password"] = this.password;
        data["Question"] = this.question;
        data["Answer"] = this.answer;
        data["Channel"] = this.channel;
        data["TierId"] = this.tierId;
        return data; 
    }
}

export interface ICustomerData {
    customerId?: string | undefined;
    password?: string | undefined;
    question?: string | undefined;
    answer?: string | undefined;
    channel?: string | undefined;
    tierId?: string | undefined;
}

export class CheckMailProspectInput implements ICheckMailProspectInput {
    mail?: string | undefined;

    constructor(data?: ICheckMailProspectInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mail = _data["mail"];
        }
    }

    static fromJS(data: any): CheckMailProspectInput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckMailProspectInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mail"] = this.mail;
        return data; 
    }
}

export interface ICheckMailProspectInput {
    mail?: string | undefined;
}

export class CheckTokenInput implements ICheckTokenInput {
    token?: string | undefined;

    constructor(data?: ICheckTokenInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): CheckTokenInput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckTokenInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data; 
    }
}

export interface ICheckTokenInput {
    token?: string | undefined;
}

export class ChangePasswordInput implements IChangePasswordInput {
    userId?: string | undefined;
    password?: string | undefined;
    cofirmPassword?: string | undefined;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.password = _data["Password"];
            this.cofirmPassword = _data["CofirmPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["Password"] = this.password;
        data["CofirmPassword"] = this.cofirmPassword;
        return data; 
    }
}

export interface IChangePasswordInput {
    userId?: string | undefined;
    password?: string | undefined;
    cofirmPassword?: string | undefined;
}

export class B3GResponseOfCollectionOfApplicationUserDeviceDto implements IB3GResponseOfCollectionOfApplicationUserDeviceDto {
    result?: ApplicationUserDeviceDto[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfCollectionOfApplicationUserDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(ApplicationUserDeviceDto.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfCollectionOfApplicationUserDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfCollectionOfApplicationUserDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfCollectionOfApplicationUserDeviceDto {
    result?: ApplicationUserDeviceDto[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class ApplicationUserDeviceDto implements IApplicationUserDeviceDto {
    id?: number | undefined;
    deviceId?: string | undefined;
    brand?: string | undefined;
    model?: string | undefined;
    serialNumber?: string | undefined;
    simSerialNumber?: string | undefined;
    gooGleEmailAccount?: string | undefined;
    status?: string | undefined;
    otpConfirmed?: string | undefined;
    otpConfirmedDate?: Date | undefined;
    userCreate?: string | undefined;
    dateCreate?: Date | undefined;
    fateLastAccess?: Date | undefined;
    dateModification?: Date | undefined;
    applicationUserId?: string | undefined;

    constructor(data?: IApplicationUserDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.deviceId = _data["deviceId"];
            this.brand = _data["brand"];
            this.model = _data["model"];
            this.serialNumber = _data["serialNumber"];
            this.simSerialNumber = _data["simSerialNumber"];
            this.gooGleEmailAccount = _data["gooGleEmailAccount"];
            this.status = _data["status"];
            this.otpConfirmed = _data["otpConfirmed"];
            this.otpConfirmedDate = _data["otpConfirmedDate"] ? new Date(_data["otpConfirmedDate"].toString()) : <any>undefined;
            this.userCreate = _data["userCreate"];
            this.dateCreate = _data["dateCreate"] ? new Date(_data["dateCreate"].toString()) : <any>undefined;
            this.fateLastAccess = _data["fateLastAccess"] ? new Date(_data["fateLastAccess"].toString()) : <any>undefined;
            this.dateModification = _data["dateModification"] ? new Date(_data["dateModification"].toString()) : <any>undefined;
            this.applicationUserId = _data["applicationUserId"];
        }
    }

    static fromJS(data: any): ApplicationUserDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUserDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deviceId"] = this.deviceId;
        data["brand"] = this.brand;
        data["model"] = this.model;
        data["serialNumber"] = this.serialNumber;
        data["simSerialNumber"] = this.simSerialNumber;
        data["gooGleEmailAccount"] = this.gooGleEmailAccount;
        data["status"] = this.status;
        data["otpConfirmed"] = this.otpConfirmed;
        data["otpConfirmedDate"] = this.otpConfirmedDate ? this.otpConfirmedDate.toISOString() : <any>undefined;
        data["userCreate"] = this.userCreate;
        data["dateCreate"] = this.dateCreate ? this.dateCreate.toISOString() : <any>undefined;
        data["fateLastAccess"] = this.fateLastAccess ? this.fateLastAccess.toISOString() : <any>undefined;
        data["dateModification"] = this.dateModification ? this.dateModification.toISOString() : <any>undefined;
        data["applicationUserId"] = this.applicationUserId;
        return data; 
    }
}

export interface IApplicationUserDeviceDto {
    id?: number | undefined;
    deviceId?: string | undefined;
    brand?: string | undefined;
    model?: string | undefined;
    serialNumber?: string | undefined;
    simSerialNumber?: string | undefined;
    gooGleEmailAccount?: string | undefined;
    status?: string | undefined;
    otpConfirmed?: string | undefined;
    otpConfirmedDate?: Date | undefined;
    userCreate?: string | undefined;
    dateCreate?: Date | undefined;
    fateLastAccess?: Date | undefined;
    dateModification?: Date | undefined;
    applicationUserId?: string | undefined;
}

export class CheckPhoneNumberInput implements ICheckPhoneNumberInput {
    email?: string | undefined;

    constructor(data?: ICheckPhoneNumberInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CheckPhoneNumberInput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckPhoneNumberInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data; 
    }
}

export interface ICheckPhoneNumberInput {
    email?: string | undefined;
}

export class ConfirmChangePasswordInput implements IConfirmChangePasswordInput {
    prospectToken?: string | undefined;
    email?: string | undefined;
    otp!: string;
    password?: string | undefined;
    confirmpassword?: string | undefined;

    constructor(data?: IConfirmChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prospectToken = _data["prospectToken"];
            this.email = _data["email"];
            this.otp = _data["otp"];
            this.password = _data["password"];
            this.confirmpassword = _data["Confirmpassword"];
        }
    }

    static fromJS(data: any): ConfirmChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prospectToken"] = this.prospectToken;
        data["email"] = this.email;
        data["otp"] = this.otp;
        data["password"] = this.password;
        data["Confirmpassword"] = this.confirmpassword;
        return data; 
    }
}

export interface IConfirmChangePasswordInput {
    prospectToken?: string | undefined;
    email?: string | undefined;
    otp: string;
    password?: string | undefined;
    confirmpassword?: string | undefined;
}

export class B3GResponseOfListOfInsuranceBankViewModel implements IB3GResponseOfListOfInsuranceBankViewModel {
    result?: InsuranceBankViewModel[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfInsuranceBankViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(InsuranceBankViewModel.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfInsuranceBankViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfInsuranceBankViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfInsuranceBankViewModel {
    result?: InsuranceBankViewModel[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class InsuranceBankViewModel implements IInsuranceBankViewModel {
    nomProduit?: string | undefined;
    numContratBen?: string | undefined;
    numContratSous?: string | undefined;
    numContrat?: string | undefined;
    myal?: string[] | undefined;
    bancAssuranceAvenirCompte?: InsuranceBankFutureAccountViewModel[] | undefined;
    bancAssurancesAvenirHabitation?: InsuranceBankFutureHousingViewModel[] | undefined;
    bancAssurancesAvenirHimaya?: InsuranceBankFutureHimayaViewModel[] | undefined;
    bancAssurancesAvenirPrevoyence?: InsuranceBankFutureProvidentViewModel[] | undefined;
    bancAssurancesAvenirEducationRetraite?: InsuranceBankFutureEducationRetirement[] | undefined;
    bancAssurancesAvenirRetraite?: InsuranceBankFutureEducationRetirement[] | undefined;
    bancAssurancesAvenirEpargne?: InsuranceBankFutureSaving[] | undefined;
    bancAssurancesAvenirEpargnePlus?: InsuranceBankFutureSavingPlus[] | undefined;

    constructor(data?: IInsuranceBankViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nomProduit = _data["NomProduit"];
            this.numContratBen = _data["NumContratBen"];
            this.numContratSous = _data["NumContratSous"];
            this.numContrat = _data["NumContrat"];
            if (Array.isArray(_data["Myal"])) {
                this.myal = [] as any;
                for (let item of _data["Myal"])
                    this.myal!.push(item);
            }
            if (Array.isArray(_data["BancAssuranceAvenirCompte"])) {
                this.bancAssuranceAvenirCompte = [] as any;
                for (let item of _data["BancAssuranceAvenirCompte"])
                    this.bancAssuranceAvenirCompte!.push(InsuranceBankFutureAccountViewModel.fromJS(item));
            }
            if (Array.isArray(_data["BancAssurancesAvenirHabitation"])) {
                this.bancAssurancesAvenirHabitation = [] as any;
                for (let item of _data["BancAssurancesAvenirHabitation"])
                    this.bancAssurancesAvenirHabitation!.push(InsuranceBankFutureHousingViewModel.fromJS(item));
            }
            if (Array.isArray(_data["BancAssurancesAvenirHimaya"])) {
                this.bancAssurancesAvenirHimaya = [] as any;
                for (let item of _data["BancAssurancesAvenirHimaya"])
                    this.bancAssurancesAvenirHimaya!.push(InsuranceBankFutureHimayaViewModel.fromJS(item));
            }
            if (Array.isArray(_data["BancAssurancesAvenirPrevoyence"])) {
                this.bancAssurancesAvenirPrevoyence = [] as any;
                for (let item of _data["BancAssurancesAvenirPrevoyence"])
                    this.bancAssurancesAvenirPrevoyence!.push(InsuranceBankFutureProvidentViewModel.fromJS(item));
            }
            if (Array.isArray(_data["BancAssurancesAvenirEducationRetraite"])) {
                this.bancAssurancesAvenirEducationRetraite = [] as any;
                for (let item of _data["BancAssurancesAvenirEducationRetraite"])
                    this.bancAssurancesAvenirEducationRetraite!.push(InsuranceBankFutureEducationRetirement.fromJS(item));
            }
            if (Array.isArray(_data["BancAssurancesAvenirRetraite"])) {
                this.bancAssurancesAvenirRetraite = [] as any;
                for (let item of _data["BancAssurancesAvenirRetraite"])
                    this.bancAssurancesAvenirRetraite!.push(InsuranceBankFutureEducationRetirement.fromJS(item));
            }
            if (Array.isArray(_data["BancAssurancesAvenirEpargne"])) {
                this.bancAssurancesAvenirEpargne = [] as any;
                for (let item of _data["BancAssurancesAvenirEpargne"])
                    this.bancAssurancesAvenirEpargne!.push(InsuranceBankFutureSaving.fromJS(item));
            }
            if (Array.isArray(_data["BancAssurancesAvenirEpargnePlus"])) {
                this.bancAssurancesAvenirEpargnePlus = [] as any;
                for (let item of _data["BancAssurancesAvenirEpargnePlus"])
                    this.bancAssurancesAvenirEpargnePlus!.push(InsuranceBankFutureSavingPlus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsuranceBankViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceBankViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NomProduit"] = this.nomProduit;
        data["NumContratBen"] = this.numContratBen;
        data["NumContratSous"] = this.numContratSous;
        data["NumContrat"] = this.numContrat;
        if (Array.isArray(this.myal)) {
            data["Myal"] = [];
            for (let item of this.myal)
                data["Myal"].push(item);
        }
        if (Array.isArray(this.bancAssuranceAvenirCompte)) {
            data["BancAssuranceAvenirCompte"] = [];
            for (let item of this.bancAssuranceAvenirCompte)
                data["BancAssuranceAvenirCompte"].push(item.toJSON());
        }
        if (Array.isArray(this.bancAssurancesAvenirHabitation)) {
            data["BancAssurancesAvenirHabitation"] = [];
            for (let item of this.bancAssurancesAvenirHabitation)
                data["BancAssurancesAvenirHabitation"].push(item.toJSON());
        }
        if (Array.isArray(this.bancAssurancesAvenirHimaya)) {
            data["BancAssurancesAvenirHimaya"] = [];
            for (let item of this.bancAssurancesAvenirHimaya)
                data["BancAssurancesAvenirHimaya"].push(item.toJSON());
        }
        if (Array.isArray(this.bancAssurancesAvenirPrevoyence)) {
            data["BancAssurancesAvenirPrevoyence"] = [];
            for (let item of this.bancAssurancesAvenirPrevoyence)
                data["BancAssurancesAvenirPrevoyence"].push(item.toJSON());
        }
        if (Array.isArray(this.bancAssurancesAvenirEducationRetraite)) {
            data["BancAssurancesAvenirEducationRetraite"] = [];
            for (let item of this.bancAssurancesAvenirEducationRetraite)
                data["BancAssurancesAvenirEducationRetraite"].push(item.toJSON());
        }
        if (Array.isArray(this.bancAssurancesAvenirRetraite)) {
            data["BancAssurancesAvenirRetraite"] = [];
            for (let item of this.bancAssurancesAvenirRetraite)
                data["BancAssurancesAvenirRetraite"].push(item.toJSON());
        }
        if (Array.isArray(this.bancAssurancesAvenirEpargne)) {
            data["BancAssurancesAvenirEpargne"] = [];
            for (let item of this.bancAssurancesAvenirEpargne)
                data["BancAssurancesAvenirEpargne"].push(item.toJSON());
        }
        if (Array.isArray(this.bancAssurancesAvenirEpargnePlus)) {
            data["BancAssurancesAvenirEpargnePlus"] = [];
            for (let item of this.bancAssurancesAvenirEpargnePlus)
                data["BancAssurancesAvenirEpargnePlus"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IInsuranceBankViewModel {
    nomProduit?: string | undefined;
    numContratBen?: string | undefined;
    numContratSous?: string | undefined;
    numContrat?: string | undefined;
    myal?: string[] | undefined;
    bancAssuranceAvenirCompte?: InsuranceBankFutureAccountViewModel[] | undefined;
    bancAssurancesAvenirHabitation?: InsuranceBankFutureHousingViewModel[] | undefined;
    bancAssurancesAvenirHimaya?: InsuranceBankFutureHimayaViewModel[] | undefined;
    bancAssurancesAvenirPrevoyence?: InsuranceBankFutureProvidentViewModel[] | undefined;
    bancAssurancesAvenirEducationRetraite?: InsuranceBankFutureEducationRetirement[] | undefined;
    bancAssurancesAvenirRetraite?: InsuranceBankFutureEducationRetirement[] | undefined;
    bancAssurancesAvenirEpargne?: InsuranceBankFutureSaving[] | undefined;
    bancAssurancesAvenirEpargnePlus?: InsuranceBankFutureSavingPlus[] | undefined;
}

export class InsuranceBankFutureAccountViewModel implements IInsuranceBankFutureAccountViewModel {
    contractNumber?: string | undefined;
    accountNumber?: string | undefined;
    prorata?: string | undefined;
    dateEffect?: Date | undefined;
    dateDeadline?: Date | undefined;
    minimumInsuredCapital?: string | undefined;
    maximumInsuredCapital?: string | undefined;
    annualBonus?: string | undefined;

    constructor(data?: IInsuranceBankFutureAccountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractNumber = _data["ContractNumber"];
            this.accountNumber = _data["AccountNumber"];
            this.prorata = _data["Prorata"];
            this.dateEffect = _data["DateEffect"] ? new Date(_data["DateEffect"].toString()) : <any>undefined;
            this.dateDeadline = _data["DateDeadline"] ? new Date(_data["DateDeadline"].toString()) : <any>undefined;
            this.minimumInsuredCapital = _data["MinimumInsuredCapital"];
            this.maximumInsuredCapital = _data["MaximumInsuredCapital"];
            this.annualBonus = _data["AnnualBonus"];
        }
    }

    static fromJS(data: any): InsuranceBankFutureAccountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceBankFutureAccountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContractNumber"] = this.contractNumber;
        data["AccountNumber"] = this.accountNumber;
        data["Prorata"] = this.prorata;
        data["DateEffect"] = this.dateEffect ? this.dateEffect.toISOString() : <any>undefined;
        data["DateDeadline"] = this.dateDeadline ? this.dateDeadline.toISOString() : <any>undefined;
        data["MinimumInsuredCapital"] = this.minimumInsuredCapital;
        data["MaximumInsuredCapital"] = this.maximumInsuredCapital;
        data["AnnualBonus"] = this.annualBonus;
        return data; 
    }
}

export interface IInsuranceBankFutureAccountViewModel {
    contractNumber?: string | undefined;
    accountNumber?: string | undefined;
    prorata?: string | undefined;
    dateEffect?: Date | undefined;
    dateDeadline?: Date | undefined;
    minimumInsuredCapital?: string | undefined;
    maximumInsuredCapital?: string | undefined;
    annualBonus?: string | undefined;
}

export class InsuranceBankFutureHousingViewModel implements IInsuranceBankFutureHousingViewModel {
    contractNumber?: string | undefined;
    accountNumber?: string | undefined;
    address?: string | undefined;
    dateEffect?: string | undefined;
    dateDeadline?: string | undefined;
    insuredValueFurniture?: string | undefined;
    insuredValueObjects?: string | undefined;
    insuredValueBuilding?: string | undefined;
    annualBonus?: string | undefined;

    constructor(data?: IInsuranceBankFutureHousingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractNumber = _data["ContractNumber"];
            this.accountNumber = _data["AccountNumber"];
            this.address = _data["Address"];
            this.dateEffect = _data["DateEffect"];
            this.dateDeadline = _data["DateDeadline"];
            this.insuredValueFurniture = _data["InsuredValueFurniture"];
            this.insuredValueObjects = _data["InsuredValueObjects"];
            this.insuredValueBuilding = _data["InsuredValueBuilding"];
            this.annualBonus = _data["AnnualBonus"];
        }
    }

    static fromJS(data: any): InsuranceBankFutureHousingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceBankFutureHousingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContractNumber"] = this.contractNumber;
        data["AccountNumber"] = this.accountNumber;
        data["Address"] = this.address;
        data["DateEffect"] = this.dateEffect;
        data["DateDeadline"] = this.dateDeadline;
        data["InsuredValueFurniture"] = this.insuredValueFurniture;
        data["InsuredValueObjects"] = this.insuredValueObjects;
        data["InsuredValueBuilding"] = this.insuredValueBuilding;
        data["AnnualBonus"] = this.annualBonus;
        return data; 
    }
}

export interface IInsuranceBankFutureHousingViewModel {
    contractNumber?: string | undefined;
    accountNumber?: string | undefined;
    address?: string | undefined;
    dateEffect?: string | undefined;
    dateDeadline?: string | undefined;
    insuredValueFurniture?: string | undefined;
    insuredValueObjects?: string | undefined;
    insuredValueBuilding?: string | undefined;
    annualBonus?: string | undefined;
}

export class InsuranceBankFutureHimayaViewModel implements IInsuranceBankFutureHimayaViewModel {
    nUM_CON?: string | undefined;
    nUM_CTE?: string | undefined;
    cON_NUM_CTE?: string | undefined;
    dAT_EFF?: string | undefined;
    dAT_ECH?: string | undefined;
    lIB_RIS_AVH?: string | undefined;
    cAP_RIS_AVH?: string | undefined;
    tERRITORIALITE?: string | undefined;
    pRIME?: string | undefined;
    pRORATA?: string | undefined;

    constructor(data?: IInsuranceBankFutureHimayaViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nUM_CON = _data["NUM_CON"];
            this.nUM_CTE = _data["NUM_CTE"];
            this.cON_NUM_CTE = _data["CON_NUM_CTE"];
            this.dAT_EFF = _data["DAT_EFF"];
            this.dAT_ECH = _data["DAT_ECH"];
            this.lIB_RIS_AVH = _data["LIB_RIS_AVH"];
            this.cAP_RIS_AVH = _data["CAP_RIS_AVH"];
            this.tERRITORIALITE = _data["TERRITORIALITE"];
            this.pRIME = _data["PRIME"];
            this.pRORATA = _data["PRORATA"];
        }
    }

    static fromJS(data: any): InsuranceBankFutureHimayaViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceBankFutureHimayaViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NUM_CON"] = this.nUM_CON;
        data["NUM_CTE"] = this.nUM_CTE;
        data["CON_NUM_CTE"] = this.cON_NUM_CTE;
        data["DAT_EFF"] = this.dAT_EFF;
        data["DAT_ECH"] = this.dAT_ECH;
        data["LIB_RIS_AVH"] = this.lIB_RIS_AVH;
        data["CAP_RIS_AVH"] = this.cAP_RIS_AVH;
        data["TERRITORIALITE"] = this.tERRITORIALITE;
        data["PRIME"] = this.pRIME;
        data["PRORATA"] = this.pRORATA;
        return data; 
    }
}

export interface IInsuranceBankFutureHimayaViewModel {
    nUM_CON?: string | undefined;
    nUM_CTE?: string | undefined;
    cON_NUM_CTE?: string | undefined;
    dAT_EFF?: string | undefined;
    dAT_ECH?: string | undefined;
    lIB_RIS_AVH?: string | undefined;
    cAP_RIS_AVH?: string | undefined;
    tERRITORIALITE?: string | undefined;
    pRIME?: string | undefined;
    pRORATA?: string | undefined;
}

export class InsuranceBankFutureProvidentViewModel implements IInsuranceBankFutureProvidentViewModel {
    beneficiaryContractNumber?: string | undefined;
    contractNumber?: string | undefined;
    accountNumber?: string | undefined;
    annualBonus?: string | undefined;
    annualBonusFirstDeadline?: string | undefined;
    guaranteedCapital?: string | undefined;
    dateEffect?: string | undefined;
    dateDeadline?: string | undefined;
    beneficiaryLastName?: string | undefined;
    beneficiaryFirstName?: string | undefined;
    beneficiary?: InsuranceBeneficiary[] | undefined;

    constructor(data?: IInsuranceBankFutureProvidentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.beneficiaryContractNumber = _data["BeneficiaryContractNumber"];
            this.contractNumber = _data["ContractNumber"];
            this.accountNumber = _data["AccountNumber"];
            this.annualBonus = _data["AnnualBonus"];
            this.annualBonusFirstDeadline = _data["AnnualBonusFirstDeadline"];
            this.guaranteedCapital = _data["GuaranteedCapital"];
            this.dateEffect = _data["DateEffect"];
            this.dateDeadline = _data["DateDeadline"];
            this.beneficiaryLastName = _data["BeneficiaryLastName"];
            this.beneficiaryFirstName = _data["BeneficiaryFirstName"];
            if (Array.isArray(_data["Beneficiary"])) {
                this.beneficiary = [] as any;
                for (let item of _data["Beneficiary"])
                    this.beneficiary!.push(InsuranceBeneficiary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsuranceBankFutureProvidentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceBankFutureProvidentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BeneficiaryContractNumber"] = this.beneficiaryContractNumber;
        data["ContractNumber"] = this.contractNumber;
        data["AccountNumber"] = this.accountNumber;
        data["AnnualBonus"] = this.annualBonus;
        data["AnnualBonusFirstDeadline"] = this.annualBonusFirstDeadline;
        data["GuaranteedCapital"] = this.guaranteedCapital;
        data["DateEffect"] = this.dateEffect;
        data["DateDeadline"] = this.dateDeadline;
        data["BeneficiaryLastName"] = this.beneficiaryLastName;
        data["BeneficiaryFirstName"] = this.beneficiaryFirstName;
        if (Array.isArray(this.beneficiary)) {
            data["Beneficiary"] = [];
            for (let item of this.beneficiary)
                data["Beneficiary"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IInsuranceBankFutureProvidentViewModel {
    beneficiaryContractNumber?: string | undefined;
    contractNumber?: string | undefined;
    accountNumber?: string | undefined;
    annualBonus?: string | undefined;
    annualBonusFirstDeadline?: string | undefined;
    guaranteedCapital?: string | undefined;
    dateEffect?: string | undefined;
    dateDeadline?: string | undefined;
    beneficiaryLastName?: string | undefined;
    beneficiaryFirstName?: string | undefined;
    beneficiary?: InsuranceBeneficiary[] | undefined;
}

export class InsuranceBankFutureEducationRetirement implements IInsuranceBankFutureEducationRetirement {
    contractNumber?: string | undefined;
    accountNumber?: string | undefined;
    productCode?: string | undefined;

    constructor(data?: IInsuranceBankFutureEducationRetirement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractNumber = _data["ContractNumber"];
            this.accountNumber = _data["AccountNumber"];
            this.productCode = _data["ProductCode"];
        }
    }

    static fromJS(data: any): InsuranceBankFutureEducationRetirement {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceBankFutureEducationRetirement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContractNumber"] = this.contractNumber;
        data["AccountNumber"] = this.accountNumber;
        data["ProductCode"] = this.productCode;
        return data; 
    }
}

export interface IInsuranceBankFutureEducationRetirement {
    contractNumber?: string | undefined;
    accountNumber?: string | undefined;
    productCode?: string | undefined;
}

export class InsuranceBankFutureSaving implements IInsuranceBankFutureSaving {
    contractNumber?: string | undefined;
    accountNumber?: string | undefined;
    productCode?: string | undefined;

    constructor(data?: IInsuranceBankFutureSaving) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractNumber = _data["ContractNumber"];
            this.accountNumber = _data["AccountNumber"];
            this.productCode = _data["ProductCode"];
        }
    }

    static fromJS(data: any): InsuranceBankFutureSaving {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceBankFutureSaving();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContractNumber"] = this.contractNumber;
        data["AccountNumber"] = this.accountNumber;
        data["ProductCode"] = this.productCode;
        return data; 
    }
}

export interface IInsuranceBankFutureSaving {
    contractNumber?: string | undefined;
    accountNumber?: string | undefined;
    productCode?: string | undefined;
}

export class InsuranceBankFutureSavingPlus implements IInsuranceBankFutureSavingPlus {
    contractNumber?: string | undefined;
    accountNumber?: string | undefined;
    productCode?: string | undefined;

    constructor(data?: IInsuranceBankFutureSavingPlus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractNumber = _data["ContractNumber"];
            this.accountNumber = _data["AccountNumber"];
            this.productCode = _data["ProductCode"];
        }
    }

    static fromJS(data: any): InsuranceBankFutureSavingPlus {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceBankFutureSavingPlus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContractNumber"] = this.contractNumber;
        data["AccountNumber"] = this.accountNumber;
        data["ProductCode"] = this.productCode;
        return data; 
    }
}

export interface IInsuranceBankFutureSavingPlus {
    contractNumber?: string | undefined;
    accountNumber?: string | undefined;
    productCode?: string | undefined;
}

export class InsuranceBeneficiary implements IInsuranceBeneficiary {
    beneficiaryFirstName?: string | undefined;
    beneficiaryLastName?: string | undefined;
    order?: number | undefined;

    constructor(data?: IInsuranceBeneficiary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.beneficiaryFirstName = _data["BeneficiaryFirstName"];
            this.beneficiaryLastName = _data["BeneficiaryLastName"];
            this.order = _data["Order"];
        }
    }

    static fromJS(data: any): InsuranceBeneficiary {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceBeneficiary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BeneficiaryFirstName"] = this.beneficiaryFirstName;
        data["BeneficiaryLastName"] = this.beneficiaryLastName;
        data["Order"] = this.order;
        return data; 
    }
}

export interface IInsuranceBeneficiary {
    beneficiaryFirstName?: string | undefined;
    beneficiaryLastName?: string | undefined;
    order?: number | undefined;
}

export class B3GResponseOfListOfInsuranceBankFutureAccountViewModel implements IB3GResponseOfListOfInsuranceBankFutureAccountViewModel {
    result?: InsuranceBankFutureAccountViewModel[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfInsuranceBankFutureAccountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(InsuranceBankFutureAccountViewModel.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfInsuranceBankFutureAccountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfInsuranceBankFutureAccountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfInsuranceBankFutureAccountViewModel {
    result?: InsuranceBankFutureAccountViewModel[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class B3GResponseOfListOfInsuranceBankFutureProvidentViewModel implements IB3GResponseOfListOfInsuranceBankFutureProvidentViewModel {
    result?: InsuranceBankFutureProvidentViewModel[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfInsuranceBankFutureProvidentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(InsuranceBankFutureProvidentViewModel.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfInsuranceBankFutureProvidentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfInsuranceBankFutureProvidentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfInsuranceBankFutureProvidentViewModel {
    result?: InsuranceBankFutureProvidentViewModel[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class B3GResponseOfListOfInsuranceBankFutureHimayaViewModel implements IB3GResponseOfListOfInsuranceBankFutureHimayaViewModel {
    result?: InsuranceBankFutureHimayaViewModel[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfInsuranceBankFutureHimayaViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(InsuranceBankFutureHimayaViewModel.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfInsuranceBankFutureHimayaViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfInsuranceBankFutureHimayaViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfInsuranceBankFutureHimayaViewModel {
    result?: InsuranceBankFutureHimayaViewModel[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class B3GResponseOfListOfOperatorViewModel implements IB3GResponseOfListOfOperatorViewModel {
    result?: OperatorViewModel[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfOperatorViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(OperatorViewModel.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfOperatorViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfOperatorViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfOperatorViewModel {
    result?: OperatorViewModel[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class OperatorViewModel implements IOperatorViewModel {
    operatorId?: string | undefined;
    label?: string | undefined;
    image?: string | undefined;
    path?: string | undefined;
    codeNova?: string | undefined;

    constructor(data?: IOperatorViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operatorId = _data["OperatorId"];
            this.label = _data["Label"];
            this.image = _data["Image"];
            this.path = _data["Path"];
            this.codeNova = _data["codeNova"];
        }
    }

    static fromJS(data: any): OperatorViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OperatorId"] = this.operatorId;
        data["Label"] = this.label;
        data["Image"] = this.image;
        data["Path"] = this.path;
        data["codeNova"] = this.codeNova;
        return data; 
    }
}

export interface IOperatorViewModel {
    operatorId?: string | undefined;
    label?: string | undefined;
    image?: string | undefined;
    path?: string | undefined;
    codeNova?: string | undefined;
}

export class B3GResponseOfListOfProfessionalDto implements IB3GResponseOfListOfProfessionalDto {
    result?: ProfessionalDto[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfProfessionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(ProfessionalDto.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfProfessionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfProfessionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfProfessionalDto {
    result?: ProfessionalDto[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class ProfessionalDto implements IProfessionalDto {
    libelle?: string | undefined;
    id?: number | undefined;
    codeSituationProfessionnelle?: string | undefined;
    affichageAutreInfo?: boolean | undefined;

    constructor(data?: IProfessionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.libelle = _data["Libelle"];
            this.id = _data["Id"];
            this.codeSituationProfessionnelle = _data["CodeSituationProfessionnelle"];
            this.affichageAutreInfo = _data["AffichageAutreInfo"];
        }
    }

    static fromJS(data: any): ProfessionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Libelle"] = this.libelle;
        data["Id"] = this.id;
        data["CodeSituationProfessionnelle"] = this.codeSituationProfessionnelle;
        data["AffichageAutreInfo"] = this.affichageAutreInfo;
        return data; 
    }
}

export interface IProfessionalDto {
    libelle?: string | undefined;
    id?: number | undefined;
    codeSituationProfessionnelle?: string | undefined;
    affichageAutreInfo?: boolean | undefined;
}

export class B3GResponseOfInt32 implements IB3GResponseOfInt32 {
    result?: number | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"];
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result;
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfInt32 {
    result?: number | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class ProspectFirstStep implements IProspectFirstStep {
    firstName?: string | undefined;
    lastName?: string | undefined;
    mail?: string | undefined;
    mobile?: string | undefined;
    operatorId?: number | undefined;
    countryCode?: string | undefined;
    nationalite?: string | undefined;
    nbChild?: number | undefined;
    password?: string | undefined;
    confirmPassowrd?: string | undefined;
    canal?: string | undefined;
    paysResidence?: number | undefined;
    areaCode?: string | undefined;
    phoneNumberWithoutAreaCode?: string | undefined;

    constructor(data?: IProspectFirstStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.mail = _data["Mail"];
            this.mobile = _data["Mobile"];
            this.operatorId = _data["OperatorId"];
            this.countryCode = _data["CountryCode"];
            this.nationalite = _data["Nationalite"];
            this.nbChild = _data["NbChild"];
            this.password = _data["Password"];
            this.confirmPassowrd = _data["ConfirmPassowrd"];
            this.canal = _data["canal"];
            this.paysResidence = _data["PaysResidence"];
            this.areaCode = _data["AreaCode"];
            this.phoneNumberWithoutAreaCode = _data["PhoneNumberWithoutAreaCode"];
        }
    }

    static fromJS(data: any): ProspectFirstStep {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectFirstStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["Mail"] = this.mail;
        data["Mobile"] = this.mobile;
        data["OperatorId"] = this.operatorId;
        data["CountryCode"] = this.countryCode;
        data["Nationalite"] = this.nationalite;
        data["NbChild"] = this.nbChild;
        data["Password"] = this.password;
        data["ConfirmPassowrd"] = this.confirmPassowrd;
        data["canal"] = this.canal;
        data["PaysResidence"] = this.paysResidence;
        data["AreaCode"] = this.areaCode;
        data["PhoneNumberWithoutAreaCode"] = this.phoneNumberWithoutAreaCode;
        return data; 
    }
}

export interface IProspectFirstStep {
    firstName?: string | undefined;
    lastName?: string | undefined;
    mail?: string | undefined;
    mobile?: string | undefined;
    operatorId?: number | undefined;
    countryCode?: string | undefined;
    nationalite?: string | undefined;
    nbChild?: number | undefined;
    password?: string | undefined;
    confirmPassowrd?: string | undefined;
    canal?: string | undefined;
    paysResidence?: number | undefined;
    areaCode?: string | undefined;
    phoneNumberWithoutAreaCode?: string | undefined;
}

export class B3GResponseOfProspectInfoDto implements IB3GResponseOfProspectInfoDto {
    result?: ProspectInfoDto | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfProspectInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"] ? ProspectInfoDto.fromJS(_data["Result"]) : <any>undefined;
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfProspectInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfProspectInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfProspectInfoDto {
    result?: ProspectInfoDto | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class ProspectInfoDto implements IProspectInfoDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    gender?: string | undefined;
    idClient?: string | undefined;
    phoneNumber?: string | undefined;
    dateBirth?: Date | undefined;
    operatorLabel?: string | undefined;
    identification?: string | undefined;
    acceptConditions?: boolean | undefined;
    rendezVousLibelle?: string | undefined;
    nbChild?: number | undefined;
    fonctionnaire?: boolean | undefined;
    prospectOffers?: ProspectOfferDto[] | undefined;
    prospectMedia?: ProspectMedia[] | undefined;
    prospectOffer?: ProspectOfferDto | undefined;
    agencyName?: string | undefined;
    agencyAdress?: string | undefined;
    agencyPhone?: string | undefined;
    agencyTime?: string | undefined;
    agenceCode?: string | undefined;
    city?: string | undefined;
    prospectProduct?: ProspectProductDto | undefined;
    folderProgress?: string | undefined;
    email?: string | undefined;
    lieuNaissance?: string | undefined;
    nomPere?: string | undefined;
    nomMere?: string | undefined;
    adresseCIN?: string | undefined;
    dateValidite?: Date | undefined;
    adrDiffCourrier?: string | undefined;
    adrDiffResidence?: string | undefined;
    paysResidence?: string | undefined;
    fatca?: boolean | undefined;
    secteurActivite?: string | undefined;
    origineDeFonds?: string | undefined;
    revenuMensuel?: string | undefined;
    autreCompte?: boolean | undefined;
    nomBanque?: string | undefined;
    situationFamilial?: string | undefined;
    nationalite?: string | undefined;
    step?: number | undefined;
    paysNaissance?: string | undefined;
    emailChecked?: boolean | undefined;
    motif?: string | undefined;
    situationProfession?: number | undefined;
    souscriptionOffre?: string | undefined;
    kwc?: string | undefined;
    profession?: string | undefined;
    countryCode?: string | undefined;
    socioProfessional?: string | undefined;
    motivationOuvCompte?: string | undefined;
    isNewSystem?: boolean | undefined;
    hasAnsweredPhoneCall?: boolean | undefined;
    isAccountCreated?: boolean | undefined;

    constructor(data?: IProspectInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.gender = _data["Gender"];
            this.idClient = _data["IdClient"];
            this.phoneNumber = _data["PhoneNumber"];
            this.dateBirth = _data["DateBirth"] ? new Date(_data["DateBirth"].toString()) : <any>undefined;
            this.operatorLabel = _data["OperatorLabel"];
            this.identification = _data["Identification"];
            this.acceptConditions = _data["AcceptConditions"];
            this.rendezVousLibelle = _data["RendezVousLibelle"];
            this.nbChild = _data["NbChild"];
            this.fonctionnaire = _data["Fonctionnaire"];
            if (Array.isArray(_data["prospectOffers"])) {
                this.prospectOffers = [] as any;
                for (let item of _data["prospectOffers"])
                    this.prospectOffers!.push(ProspectOfferDto.fromJS(item));
            }
            if (Array.isArray(_data["ProspectMedia"])) {
                this.prospectMedia = [] as any;
                for (let item of _data["ProspectMedia"])
                    this.prospectMedia!.push(ProspectMedia.fromJS(item));
            }
            this.prospectOffer = _data["prospectOffer"] ? ProspectOfferDto.fromJS(_data["prospectOffer"]) : <any>undefined;
            this.agencyName = _data["AgencyName"];
            this.agencyAdress = _data["AgencyAdress"];
            this.agencyPhone = _data["AgencyPhone"];
            this.agencyTime = _data["AgencyTime"];
            this.agenceCode = _data["AgenceCode"];
            this.city = _data["City"];
            this.prospectProduct = _data["ProspectProduct"] ? ProspectProductDto.fromJS(_data["ProspectProduct"]) : <any>undefined;
            this.folderProgress = _data["FolderProgress"];
            this.email = _data["Email"];
            this.lieuNaissance = _data["LieuNaissance"];
            this.nomPere = _data["NomPere"];
            this.nomMere = _data["NomMere"];
            this.adresseCIN = _data["AdresseCIN"];
            this.dateValidite = _data["DateValidite"] ? new Date(_data["DateValidite"].toString()) : <any>undefined;
            this.adrDiffCourrier = _data["AdrDiffCourrier"];
            this.adrDiffResidence = _data["AdrDiffResidence"];
            this.paysResidence = _data["PaysResidence"];
            this.fatca = _data["fatca"];
            this.secteurActivite = _data["SecteurActivite"];
            this.origineDeFonds = _data["origineDeFonds"];
            this.revenuMensuel = _data["RevenuMensuel"];
            this.autreCompte = _data["AutreCompte"];
            this.nomBanque = _data["NomBanque"];
            this.situationFamilial = _data["SituationFamilial"];
            this.nationalite = _data["Nationalite"];
            this.step = _data["step"];
            this.paysNaissance = _data["paysNaissance"];
            this.emailChecked = _data["emailChecked"];
            this.motif = _data["motif"];
            this.situationProfession = _data["SituationProfession"];
            this.souscriptionOffre = _data["souscriptionOffre"];
            this.kwc = _data["kwc"];
            this.profession = _data["Profession"];
            this.countryCode = _data["CountryCode"];
            this.socioProfessional = _data["SocioProfessional"];
            this.motivationOuvCompte = _data["MotivationOuvCompte"];
            this.isNewSystem = _data["isNewSystem"];
            this.hasAnsweredPhoneCall = _data["HasAnsweredPhoneCall"];
            this.isAccountCreated = _data["IsAccountCreated"];
        }
    }

    static fromJS(data: any): ProspectInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["Gender"] = this.gender;
        data["IdClient"] = this.idClient;
        data["PhoneNumber"] = this.phoneNumber;
        data["DateBirth"] = this.dateBirth ? this.dateBirth.toISOString() : <any>undefined;
        data["OperatorLabel"] = this.operatorLabel;
        data["Identification"] = this.identification;
        data["AcceptConditions"] = this.acceptConditions;
        data["RendezVousLibelle"] = this.rendezVousLibelle;
        data["NbChild"] = this.nbChild;
        data["Fonctionnaire"] = this.fonctionnaire;
        if (Array.isArray(this.prospectOffers)) {
            data["prospectOffers"] = [];
            for (let item of this.prospectOffers)
                data["prospectOffers"].push(item.toJSON());
        }
        if (Array.isArray(this.prospectMedia)) {
            data["ProspectMedia"] = [];
            for (let item of this.prospectMedia)
                data["ProspectMedia"].push(item.toJSON());
        }
        data["prospectOffer"] = this.prospectOffer ? this.prospectOffer.toJSON() : <any>undefined;
        data["AgencyName"] = this.agencyName;
        data["AgencyAdress"] = this.agencyAdress;
        data["AgencyPhone"] = this.agencyPhone;
        data["AgencyTime"] = this.agencyTime;
        data["AgenceCode"] = this.agenceCode;
        data["City"] = this.city;
        data["ProspectProduct"] = this.prospectProduct ? this.prospectProduct.toJSON() : <any>undefined;
        data["FolderProgress"] = this.folderProgress;
        data["Email"] = this.email;
        data["LieuNaissance"] = this.lieuNaissance;
        data["NomPere"] = this.nomPere;
        data["NomMere"] = this.nomMere;
        data["AdresseCIN"] = this.adresseCIN;
        data["DateValidite"] = this.dateValidite ? this.dateValidite.toISOString() : <any>undefined;
        data["AdrDiffCourrier"] = this.adrDiffCourrier;
        data["AdrDiffResidence"] = this.adrDiffResidence;
        data["PaysResidence"] = this.paysResidence;
        data["fatca"] = this.fatca;
        data["SecteurActivite"] = this.secteurActivite;
        data["origineDeFonds"] = this.origineDeFonds;
        data["RevenuMensuel"] = this.revenuMensuel;
        data["AutreCompte"] = this.autreCompte;
        data["NomBanque"] = this.nomBanque;
        data["SituationFamilial"] = this.situationFamilial;
        data["Nationalite"] = this.nationalite;
        data["step"] = this.step;
        data["paysNaissance"] = this.paysNaissance;
        data["emailChecked"] = this.emailChecked;
        data["motif"] = this.motif;
        data["SituationProfession"] = this.situationProfession;
        data["souscriptionOffre"] = this.souscriptionOffre;
        data["kwc"] = this.kwc;
        data["Profession"] = this.profession;
        data["CountryCode"] = this.countryCode;
        data["SocioProfessional"] = this.socioProfessional;
        data["MotivationOuvCompte"] = this.motivationOuvCompte;
        data["isNewSystem"] = this.isNewSystem;
        data["HasAnsweredPhoneCall"] = this.hasAnsweredPhoneCall;
        data["IsAccountCreated"] = this.isAccountCreated;
        return data; 
    }
}

export interface IProspectInfoDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    gender?: string | undefined;
    idClient?: string | undefined;
    phoneNumber?: string | undefined;
    dateBirth?: Date | undefined;
    operatorLabel?: string | undefined;
    identification?: string | undefined;
    acceptConditions?: boolean | undefined;
    rendezVousLibelle?: string | undefined;
    nbChild?: number | undefined;
    fonctionnaire?: boolean | undefined;
    prospectOffers?: ProspectOfferDto[] | undefined;
    prospectMedia?: ProspectMedia[] | undefined;
    prospectOffer?: ProspectOfferDto | undefined;
    agencyName?: string | undefined;
    agencyAdress?: string | undefined;
    agencyPhone?: string | undefined;
    agencyTime?: string | undefined;
    agenceCode?: string | undefined;
    city?: string | undefined;
    prospectProduct?: ProspectProductDto | undefined;
    folderProgress?: string | undefined;
    email?: string | undefined;
    lieuNaissance?: string | undefined;
    nomPere?: string | undefined;
    nomMere?: string | undefined;
    adresseCIN?: string | undefined;
    dateValidite?: Date | undefined;
    adrDiffCourrier?: string | undefined;
    adrDiffResidence?: string | undefined;
    paysResidence?: string | undefined;
    fatca?: boolean | undefined;
    secteurActivite?: string | undefined;
    origineDeFonds?: string | undefined;
    revenuMensuel?: string | undefined;
    autreCompte?: boolean | undefined;
    nomBanque?: string | undefined;
    situationFamilial?: string | undefined;
    nationalite?: string | undefined;
    step?: number | undefined;
    paysNaissance?: string | undefined;
    emailChecked?: boolean | undefined;
    motif?: string | undefined;
    situationProfession?: number | undefined;
    souscriptionOffre?: string | undefined;
    kwc?: string | undefined;
    profession?: string | undefined;
    countryCode?: string | undefined;
    socioProfessional?: string | undefined;
    motivationOuvCompte?: string | undefined;
    isNewSystem?: boolean | undefined;
    hasAnsweredPhoneCall?: boolean | undefined;
    isAccountCreated?: boolean | undefined;
}

export class ProspectOfferDto implements IProspectOfferDto {
    offerId?: string | undefined;
    offerLabel?: string | undefined;
    description?: string | undefined;
    offerPicture?: string | undefined;
    productID?: string | undefined;
    prix?: string | undefined;
    productType?: string | undefined;

    constructor(data?: IProspectOfferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerId = _data["OfferId"];
            this.offerLabel = _data["OfferLabel"];
            this.description = _data["Description"];
            this.offerPicture = _data["OfferPicture"];
            this.productID = _data["ProductID"];
            this.prix = _data["prix"];
            this.productType = _data["ProductType"];
        }
    }

    static fromJS(data: any): ProspectOfferDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectOfferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OfferId"] = this.offerId;
        data["OfferLabel"] = this.offerLabel;
        data["Description"] = this.description;
        data["OfferPicture"] = this.offerPicture;
        data["ProductID"] = this.productID;
        data["prix"] = this.prix;
        data["ProductType"] = this.productType;
        return data; 
    }
}

export interface IProspectOfferDto {
    offerId?: string | undefined;
    offerLabel?: string | undefined;
    description?: string | undefined;
    offerPicture?: string | undefined;
    productID?: string | undefined;
    prix?: string | undefined;
    productType?: string | undefined;
}

export class ProspectMedia implements IProspectMedia {
    id?: number | undefined;
    description?: string | undefined;
    type?: string | undefined;

    constructor(data?: IProspectMedia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.description = _data["Description"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): ProspectMedia {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectMedia();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Description"] = this.description;
        data["Type"] = this.type;
        return data; 
    }
}

export interface IProspectMedia {
    id?: number | undefined;
    description?: string | undefined;
    type?: string | undefined;
}

export class ProspectProductDto implements IProspectProductDto {
    id?: string | undefined;
    libelle?: string | undefined;
    picture?: string | undefined;
    prix?: string | undefined;
    description?: string | undefined;

    constructor(data?: IProspectProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.libelle = _data["Libelle"];
            this.picture = _data["Picture"];
            this.prix = _data["Prix"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): ProspectProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Libelle"] = this.libelle;
        data["Picture"] = this.picture;
        data["Prix"] = this.prix;
        data["Description"] = this.description;
        return data; 
    }
}

export interface IProspectProductDto {
    id?: string | undefined;
    libelle?: string | undefined;
    picture?: string | undefined;
    prix?: string | undefined;
    description?: string | undefined;
}

export class ConfirmGSMInput implements IConfirmGSMInput {
    numberPhone?: string | undefined;
    otp!: string;
    email?: string | undefined;
    prospectToken?: string | undefined;

    constructor(data?: IConfirmGSMInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberPhone = _data["numberPhone"];
            this.otp = _data["otp"];
            this.email = _data["email"];
            this.prospectToken = _data["prospectToken"];
        }
    }

    static fromJS(data: any): ConfirmGSMInput {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmGSMInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberPhone"] = this.numberPhone;
        data["otp"] = this.otp;
        data["email"] = this.email;
        data["prospectToken"] = this.prospectToken;
        return data; 
    }
}

export interface IConfirmGSMInput {
    numberPhone?: string | undefined;
    otp: string;
    email?: string | undefined;
    prospectToken?: string | undefined;
}

export class CompleteProspectDto implements ICompleteProspectDto {
    id?: string | undefined;
    countryId?: number | undefined;
    situationProfession?: number | undefined;
    productId?: number | undefined;
    offerId?: number | undefined;
    parentId?: number | undefined;
    profession?: string | undefined;
    identification?: string | undefined;
    cinRecto?: MediaFileProspectDto | undefined;
    cinVerso?: MediaFileProspectDto | undefined;
    actEngagement?: MediaFileProspectDto | undefined;
    listChildProspectDto?: ChildProspectDto[] | undefined;

    constructor(data?: ICompleteProspectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.countryId = _data["CountryId"];
            this.situationProfession = _data["SituationProfession"];
            this.productId = _data["ProductId"];
            this.offerId = _data["OfferId"];
            this.parentId = _data["ParentId"];
            this.profession = _data["Profession"];
            this.identification = _data["Identification"];
            this.cinRecto = _data["CinRecto"] ? MediaFileProspectDto.fromJS(_data["CinRecto"]) : <any>undefined;
            this.cinVerso = _data["CinVerso"] ? MediaFileProspectDto.fromJS(_data["CinVerso"]) : <any>undefined;
            this.actEngagement = _data["ActEngagement"] ? MediaFileProspectDto.fromJS(_data["ActEngagement"]) : <any>undefined;
            if (Array.isArray(_data["ListChildProspectDto"])) {
                this.listChildProspectDto = [] as any;
                for (let item of _data["ListChildProspectDto"])
                    this.listChildProspectDto!.push(ChildProspectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompleteProspectDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteProspectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CountryId"] = this.countryId;
        data["SituationProfession"] = this.situationProfession;
        data["ProductId"] = this.productId;
        data["OfferId"] = this.offerId;
        data["ParentId"] = this.parentId;
        data["Profession"] = this.profession;
        data["Identification"] = this.identification;
        data["CinRecto"] = this.cinRecto ? this.cinRecto.toJSON() : <any>undefined;
        data["CinVerso"] = this.cinVerso ? this.cinVerso.toJSON() : <any>undefined;
        data["ActEngagement"] = this.actEngagement ? this.actEngagement.toJSON() : <any>undefined;
        if (Array.isArray(this.listChildProspectDto)) {
            data["ListChildProspectDto"] = [];
            for (let item of this.listChildProspectDto)
                data["ListChildProspectDto"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICompleteProspectDto {
    id?: string | undefined;
    countryId?: number | undefined;
    situationProfession?: number | undefined;
    productId?: number | undefined;
    offerId?: number | undefined;
    parentId?: number | undefined;
    profession?: string | undefined;
    identification?: string | undefined;
    cinRecto?: MediaFileProspectDto | undefined;
    cinVerso?: MediaFileProspectDto | undefined;
    actEngagement?: MediaFileProspectDto | undefined;
    listChildProspectDto?: ChildProspectDto[] | undefined;
}

export class MediaFileProspectDto implements IMediaFileProspectDto {
    prospectId?: number | undefined;
    parentId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    mimeType?: string | undefined;
    type?: string | undefined;
    size?: number | undefined;
    fileContent?: string | undefined;
    upsizeTs?: string | undefined;
    fileThumb?: string | undefined;

    constructor(data?: IMediaFileProspectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prospectId = _data["ProspectId"];
            this.parentId = _data["ParentId"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.mimeType = _data["MimeType"];
            this.type = _data["Type"];
            this.size = _data["Size"];
            this.fileContent = _data["FileContent"];
            this.upsizeTs = _data["UpsizeTs"];
            this.fileThumb = _data["FileThumb"];
        }
    }

    static fromJS(data: any): MediaFileProspectDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaFileProspectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProspectId"] = this.prospectId;
        data["ParentId"] = this.parentId;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["MimeType"] = this.mimeType;
        data["Type"] = this.type;
        data["Size"] = this.size;
        data["FileContent"] = this.fileContent;
        data["UpsizeTs"] = this.upsizeTs;
        data["FileThumb"] = this.fileThumb;
        return data; 
    }
}

export interface IMediaFileProspectDto {
    prospectId?: number | undefined;
    parentId?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    mimeType?: string | undefined;
    type?: string | undefined;
    size?: number | undefined;
    fileContent?: string | undefined;
    upsizeTs?: string | undefined;
    fileThumb?: string | undefined;
}

export class ChildProspectDto implements IChildProspectDto {
    id?: number | undefined;
    gender?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    offerId?: number | undefined;
    productId?: number | undefined;
    fileRectoModel?: MediaFileProspectDto | undefined;

    constructor(data?: IChildProspectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.gender = _data["Gender"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.dateOfBirth = _data["DateOfBirth"] ? new Date(_data["DateOfBirth"].toString()) : <any>undefined;
            this.offerId = _data["OfferId"];
            this.productId = _data["ProductId"];
            this.fileRectoModel = _data["FileRectoModel"] ? MediaFileProspectDto.fromJS(_data["FileRectoModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChildProspectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChildProspectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Gender"] = this.gender;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["DateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["OfferId"] = this.offerId;
        data["ProductId"] = this.productId;
        data["FileRectoModel"] = this.fileRectoModel ? this.fileRectoModel.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IChildProspectDto {
    id?: number | undefined;
    gender?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: Date | undefined;
    offerId?: number | undefined;
    productId?: number | undefined;
    fileRectoModel?: MediaFileProspectDto | undefined;
}

export class TakeAppointmentDto implements ITakeAppointmentDto {
    id?: string | undefined;
    city?: string | undefined;
    agenceCode?: string | undefined;
    appointmentDateTime?: string | undefined;
    day?: string | undefined;
    canal?: string | undefined;
    isImmidiat?: boolean | undefined;
    isAdresseAgence?: boolean | undefined;
    isAdresseCin?: boolean | undefined;
    cityAdresseCin?: string | undefined;
    isOtherAdresse?: boolean | undefined;
    cityOtherAdresse?: string | undefined;
    adresse?: string | undefined;
    acceptConditionsHorsAgence?: boolean | undefined;

    constructor(data?: ITakeAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.city = _data["City"];
            this.agenceCode = _data["AgenceCode"];
            this.appointmentDateTime = _data["AppointmentDateTime"];
            this.day = _data["day"];
            this.canal = _data["canal"];
            this.isImmidiat = _data["IsImmidiat"];
            this.isAdresseAgence = _data["IsAdresseAgence"];
            this.isAdresseCin = _data["IsAdresseCin"];
            this.cityAdresseCin = _data["CityAdresseCin"];
            this.isOtherAdresse = _data["IsOtherAdresse"];
            this.cityOtherAdresse = _data["CityOtherAdresse"];
            this.adresse = _data["Adresse"];
            this.acceptConditionsHorsAgence = _data["AcceptConditionsHorsAgence"];
        }
    }

    static fromJS(data: any): TakeAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new TakeAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["City"] = this.city;
        data["AgenceCode"] = this.agenceCode;
        data["AppointmentDateTime"] = this.appointmentDateTime;
        data["day"] = this.day;
        data["canal"] = this.canal;
        data["IsImmidiat"] = this.isImmidiat;
        data["IsAdresseAgence"] = this.isAdresseAgence;
        data["IsAdresseCin"] = this.isAdresseCin;
        data["CityAdresseCin"] = this.cityAdresseCin;
        data["IsOtherAdresse"] = this.isOtherAdresse;
        data["CityOtherAdresse"] = this.cityOtherAdresse;
        data["Adresse"] = this.adresse;
        data["AcceptConditionsHorsAgence"] = this.acceptConditionsHorsAgence;
        return data; 
    }
}

export interface ITakeAppointmentDto {
    id?: string | undefined;
    city?: string | undefined;
    agenceCode?: string | undefined;
    appointmentDateTime?: string | undefined;
    day?: string | undefined;
    canal?: string | undefined;
    isImmidiat?: boolean | undefined;
    isAdresseAgence?: boolean | undefined;
    isAdresseCin?: boolean | undefined;
    cityAdresseCin?: string | undefined;
    isOtherAdresse?: boolean | undefined;
    cityOtherAdresse?: string | undefined;
    adresse?: string | undefined;
    acceptConditionsHorsAgence?: boolean | undefined;
}

export class MobileFinalizeProcess implements IMobileFinalizeProcess {
    signature?: MediaFileProspectDto | undefined;
    day?: string | undefined;
    canal?: string | undefined;

    constructor(data?: IMobileFinalizeProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signature = _data["Signature"] ? MediaFileProspectDto.fromJS(_data["Signature"]) : <any>undefined;
            this.day = _data["day"];
            this.canal = _data["canal"];
        }
    }

    static fromJS(data: any): MobileFinalizeProcess {
        data = typeof data === 'object' ? data : {};
        let result = new MobileFinalizeProcess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Signature"] = this.signature ? this.signature.toJSON() : <any>undefined;
        data["day"] = this.day;
        data["canal"] = this.canal;
        return data; 
    }
}

export interface IMobileFinalizeProcess {
    signature?: MediaFileProspectDto | undefined;
    day?: string | undefined;
    canal?: string | undefined;
}

export class B3GResponseOfFolderProgressOutput implements IB3GResponseOfFolderProgressOutput {
    result?: FolderProgressOutput | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfFolderProgressOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"] ? FolderProgressOutput.fromJS(_data["Result"]) : <any>undefined;
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfFolderProgressOutput {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfFolderProgressOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfFolderProgressOutput {
    result?: FolderProgressOutput | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class FolderProgressOutput implements IFolderProgressOutput {
    statusCard?: string | undefined;
    rIBReady?: boolean | undefined;
    accountState?: string | undefined;
    tokenMail?: string | undefined;
    badfiles?: string[] | undefined;

    constructor(data?: IFolderProgressOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCard = _data["StatusCard"];
            this.rIBReady = _data["RIBReady"];
            this.accountState = _data["AccountState"];
            this.tokenMail = _data["TokenMail"];
            if (Array.isArray(_data["Badfiles"])) {
                this.badfiles = [] as any;
                for (let item of _data["Badfiles"])
                    this.badfiles!.push(item);
            }
        }
    }

    static fromJS(data: any): FolderProgressOutput {
        data = typeof data === 'object' ? data : {};
        let result = new FolderProgressOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StatusCard"] = this.statusCard;
        data["RIBReady"] = this.rIBReady;
        data["AccountState"] = this.accountState;
        data["TokenMail"] = this.tokenMail;
        if (Array.isArray(this.badfiles)) {
            data["Badfiles"] = [];
            for (let item of this.badfiles)
                data["Badfiles"].push(item);
        }
        return data; 
    }
}

export interface IFolderProgressOutput {
    statusCard?: string | undefined;
    rIBReady?: boolean | undefined;
    accountState?: string | undefined;
    tokenMail?: string | undefined;
    badfiles?: string[] | undefined;
}

export class BadFilesInput implements IBadFilesInput {
    recto?: MediaFileProspectDto | undefined;
    verso?: MediaFileProspectDto | undefined;
    extrait?: MediaFileProspectDto | undefined;
    justificationAdressDuCourrier?: MediaFileProspectDto | undefined;
    justificationAdressDuResidence?: MediaFileProspectDto | undefined;
    signature?: MediaFileProspectDto | undefined;
    mRERecto?: MediaFileProspectDto | undefined;
    mREVerso?: MediaFileProspectDto | undefined;
    prospectId?: string | undefined;

    constructor(data?: IBadFilesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recto = _data["Recto"] ? MediaFileProspectDto.fromJS(_data["Recto"]) : <any>undefined;
            this.verso = _data["Verso"] ? MediaFileProspectDto.fromJS(_data["Verso"]) : <any>undefined;
            this.extrait = _data["Extrait"] ? MediaFileProspectDto.fromJS(_data["Extrait"]) : <any>undefined;
            this.justificationAdressDuCourrier = _data["JustificationAdressDuCourrier"] ? MediaFileProspectDto.fromJS(_data["JustificationAdressDuCourrier"]) : <any>undefined;
            this.justificationAdressDuResidence = _data["JustificationAdressDuResidence"] ? MediaFileProspectDto.fromJS(_data["JustificationAdressDuResidence"]) : <any>undefined;
            this.signature = _data["Signature"] ? MediaFileProspectDto.fromJS(_data["Signature"]) : <any>undefined;
            this.mRERecto = _data["MRERecto"] ? MediaFileProspectDto.fromJS(_data["MRERecto"]) : <any>undefined;
            this.mREVerso = _data["MREVerso"] ? MediaFileProspectDto.fromJS(_data["MREVerso"]) : <any>undefined;
            this.prospectId = _data["ProspectId"];
        }
    }

    static fromJS(data: any): BadFilesInput {
        data = typeof data === 'object' ? data : {};
        let result = new BadFilesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Recto"] = this.recto ? this.recto.toJSON() : <any>undefined;
        data["Verso"] = this.verso ? this.verso.toJSON() : <any>undefined;
        data["Extrait"] = this.extrait ? this.extrait.toJSON() : <any>undefined;
        data["JustificationAdressDuCourrier"] = this.justificationAdressDuCourrier ? this.justificationAdressDuCourrier.toJSON() : <any>undefined;
        data["JustificationAdressDuResidence"] = this.justificationAdressDuResidence ? this.justificationAdressDuResidence.toJSON() : <any>undefined;
        data["Signature"] = this.signature ? this.signature.toJSON() : <any>undefined;
        data["MRERecto"] = this.mRERecto ? this.mRERecto.toJSON() : <any>undefined;
        data["MREVerso"] = this.mREVerso ? this.mREVerso.toJSON() : <any>undefined;
        data["ProspectId"] = this.prospectId;
        return data; 
    }
}

export interface IBadFilesInput {
    recto?: MediaFileProspectDto | undefined;
    verso?: MediaFileProspectDto | undefined;
    extrait?: MediaFileProspectDto | undefined;
    justificationAdressDuCourrier?: MediaFileProspectDto | undefined;
    justificationAdressDuResidence?: MediaFileProspectDto | undefined;
    signature?: MediaFileProspectDto | undefined;
    mRERecto?: MediaFileProspectDto | undefined;
    mREVerso?: MediaFileProspectDto | undefined;
    prospectId?: string | undefined;
}

export class MobileCompleteProspectDto implements IMobileCompleteProspectDto {
    canal?: string | undefined;
    firstName?: InfoOCR | undefined;
    lastName?: InfoOCR | undefined;
    dateBirth?: InfoOCR | undefined;
    lieuNaissance?: InfoOCR | undefined;
    nomPere?: InfoOCR | undefined;
    nomMere?: InfoOCR | undefined;
    adresseCIN?: InfoOCR | undefined;
    adrDiffCourrier?: string | undefined;
    adrDiffResidence?: string | undefined;
    dateValididte?: InfoOCR | undefined;
    gender?: string | undefined;
    insertOrModif?: string | undefined;
    identification?: InfoOCR | undefined;
    cinRecto?: MediaFileProspectDto | undefined;
    cinVerso?: MediaFileProspectDto | undefined;
    profilePicture?: MediaFileProspectDto | undefined;
    justificatifAdresseResidence?: MediaFileProspectDto | undefined;
    justificatifAdresseCourier?: MediaFileProspectDto | undefined;

    constructor(data?: IMobileCompleteProspectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canal = _data["canal"];
            this.firstName = _data["FirstName"] ? InfoOCR.fromJS(_data["FirstName"]) : <any>undefined;
            this.lastName = _data["LastName"] ? InfoOCR.fromJS(_data["LastName"]) : <any>undefined;
            this.dateBirth = _data["DateBirth"] ? InfoOCR.fromJS(_data["DateBirth"]) : <any>undefined;
            this.lieuNaissance = _data["LieuNaissance"] ? InfoOCR.fromJS(_data["LieuNaissance"]) : <any>undefined;
            this.nomPere = _data["NomPere"] ? InfoOCR.fromJS(_data["NomPere"]) : <any>undefined;
            this.nomMere = _data["NomMere"] ? InfoOCR.fromJS(_data["NomMere"]) : <any>undefined;
            this.adresseCIN = _data["AdresseCIN"] ? InfoOCR.fromJS(_data["AdresseCIN"]) : <any>undefined;
            this.adrDiffCourrier = _data["AdrDiffCourrier"];
            this.adrDiffResidence = _data["AdrDiffResidence"];
            this.dateValididte = _data["DateValididte"] ? InfoOCR.fromJS(_data["DateValididte"]) : <any>undefined;
            this.gender = _data["gender"];
            this.insertOrModif = _data["InsertOrModif"];
            this.identification = _data["Identification"] ? InfoOCR.fromJS(_data["Identification"]) : <any>undefined;
            this.cinRecto = _data["CinRecto"] ? MediaFileProspectDto.fromJS(_data["CinRecto"]) : <any>undefined;
            this.cinVerso = _data["CinVerso"] ? MediaFileProspectDto.fromJS(_data["CinVerso"]) : <any>undefined;
            this.profilePicture = _data["ProfilePicture"] ? MediaFileProspectDto.fromJS(_data["ProfilePicture"]) : <any>undefined;
            this.justificatifAdresseResidence = _data["JustificatifAdresseResidence"] ? MediaFileProspectDto.fromJS(_data["JustificatifAdresseResidence"]) : <any>undefined;
            this.justificatifAdresseCourier = _data["JustificatifAdresseCourier"] ? MediaFileProspectDto.fromJS(_data["JustificatifAdresseCourier"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MobileCompleteProspectDto {
        data = typeof data === 'object' ? data : {};
        let result = new MobileCompleteProspectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canal"] = this.canal;
        data["FirstName"] = this.firstName ? this.firstName.toJSON() : <any>undefined;
        data["LastName"] = this.lastName ? this.lastName.toJSON() : <any>undefined;
        data["DateBirth"] = this.dateBirth ? this.dateBirth.toJSON() : <any>undefined;
        data["LieuNaissance"] = this.lieuNaissance ? this.lieuNaissance.toJSON() : <any>undefined;
        data["NomPere"] = this.nomPere ? this.nomPere.toJSON() : <any>undefined;
        data["NomMere"] = this.nomMere ? this.nomMere.toJSON() : <any>undefined;
        data["AdresseCIN"] = this.adresseCIN ? this.adresseCIN.toJSON() : <any>undefined;
        data["AdrDiffCourrier"] = this.adrDiffCourrier;
        data["AdrDiffResidence"] = this.adrDiffResidence;
        data["DateValididte"] = this.dateValididte ? this.dateValididte.toJSON() : <any>undefined;
        data["gender"] = this.gender;
        data["InsertOrModif"] = this.insertOrModif;
        data["Identification"] = this.identification ? this.identification.toJSON() : <any>undefined;
        data["CinRecto"] = this.cinRecto ? this.cinRecto.toJSON() : <any>undefined;
        data["CinVerso"] = this.cinVerso ? this.cinVerso.toJSON() : <any>undefined;
        data["ProfilePicture"] = this.profilePicture ? this.profilePicture.toJSON() : <any>undefined;
        data["JustificatifAdresseResidence"] = this.justificatifAdresseResidence ? this.justificatifAdresseResidence.toJSON() : <any>undefined;
        data["JustificatifAdresseCourier"] = this.justificatifAdresseCourier ? this.justificatifAdresseCourier.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMobileCompleteProspectDto {
    canal?: string | undefined;
    firstName?: InfoOCR | undefined;
    lastName?: InfoOCR | undefined;
    dateBirth?: InfoOCR | undefined;
    lieuNaissance?: InfoOCR | undefined;
    nomPere?: InfoOCR | undefined;
    nomMere?: InfoOCR | undefined;
    adresseCIN?: InfoOCR | undefined;
    adrDiffCourrier?: string | undefined;
    adrDiffResidence?: string | undefined;
    dateValididte?: InfoOCR | undefined;
    gender?: string | undefined;
    insertOrModif?: string | undefined;
    identification?: InfoOCR | undefined;
    cinRecto?: MediaFileProspectDto | undefined;
    cinVerso?: MediaFileProspectDto | undefined;
    profilePicture?: MediaFileProspectDto | undefined;
    justificatifAdresseResidence?: MediaFileProspectDto | undefined;
    justificatifAdresseCourier?: MediaFileProspectDto | undefined;
}

export class InfoOCR implements IInfoOCR {
    value?: string | undefined;
    modified?: boolean | undefined;

    constructor(data?: IInfoOCR) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.modified = _data["modified"];
        }
    }

    static fromJS(data: any): InfoOCR {
        data = typeof data === 'object' ? data : {};
        let result = new InfoOCR();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["modified"] = this.modified;
        return data; 
    }
}

export interface IInfoOCR {
    value?: string | undefined;
    modified?: boolean | undefined;
}

export class TokenInput implements ITokenInput {
    prospectToken?: string | undefined;
    email?: string | undefined;

    constructor(data?: ITokenInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prospectToken = _data["prospectToken"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): TokenInput {
        data = typeof data === 'object' ? data : {};
        let result = new TokenInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prospectToken"] = this.prospectToken;
        data["email"] = this.email;
        return data; 
    }
}

export interface ITokenInput {
    prospectToken?: string | undefined;
    email?: string | undefined;
}

export class OtpInput implements IOtpInput {
    otp?: string | undefined;
    token?: string | undefined;

    constructor(data?: IOtpInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.otp = _data["otp"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): OtpInput {
        data = typeof data === 'object' ? data : {};
        let result = new OtpInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["otp"] = this.otp;
        data["token"] = this.token;
        return data; 
    }
}

export interface IOtpInput {
    otp?: string | undefined;
    token?: string | undefined;
}

export class MobileConfirmGSMInput implements IMobileConfirmGSMInput {
    prospectToken?: string | undefined;
    numberPhone?: string | undefined;
    otp!: string;
    password?: string | undefined;
    canal?: string | undefined;

    constructor(data?: IMobileConfirmGSMInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prospectToken = _data["prospectToken"];
            this.numberPhone = _data["numberPhone"];
            this.otp = _data["otp"];
            this.password = _data["password"];
            this.canal = _data["canal"];
        }
    }

    static fromJS(data: any): MobileConfirmGSMInput {
        data = typeof data === 'object' ? data : {};
        let result = new MobileConfirmGSMInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prospectToken"] = this.prospectToken;
        data["numberPhone"] = this.numberPhone;
        data["otp"] = this.otp;
        data["password"] = this.password;
        data["canal"] = this.canal;
        return data; 
    }
}

export interface IMobileConfirmGSMInput {
    prospectToken?: string | undefined;
    numberPhone?: string | undefined;
    otp: string;
    password?: string | undefined;
    canal?: string | undefined;
}

export class ChangeEmail implements IChangeEmail {
    prospectToken?: string | undefined;
    mail?: string | undefined;

    constructor(data?: IChangeEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prospectToken = _data["prospectToken"];
            this.mail = _data["mail"];
        }
    }

    static fromJS(data: any): ChangeEmail {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prospectToken"] = this.prospectToken;
        data["mail"] = this.mail;
        return data; 
    }
}

export interface IChangeEmail {
    prospectToken?: string | undefined;
    mail?: string | undefined;
}

export class InfoProspect implements IInfoProspect {
    situationFamilial?: string | undefined;
    paysNaissance?: string | undefined;
    fonctionnaire?: boolean | undefined;
    motif?: string | undefined;
    fatca?: boolean | undefined;
    situationProfessionnelle?: number | undefined;
    profession?: string | undefined;
    socioProfessinal?: string | undefined;
    secteurActivite?: string | undefined;
    origineFonds?: string | undefined;
    revenuMensuelle?: string | undefined;
    otherAccount?: boolean | undefined;
    souscriptionOffre?: string | undefined;
    autreSouscriptionOffre?: string | undefined;
    nmBanque?: string | undefined;
    canal?: string | undefined;
    actEngagement?: MediaFileProspectDto | undefined;
    mRERecto?: MediaFileProspectDto | undefined;
    mREVerso?: MediaFileProspectDto | undefined;

    constructor(data?: IInfoProspect) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.situationFamilial = _data["SituationFamilial"];
            this.paysNaissance = _data["PaysNaissance"];
            this.fonctionnaire = _data["fonctionnaire"];
            this.motif = _data["Motif"];
            this.fatca = _data["fatca"];
            this.situationProfessionnelle = _data["SituationProfessionnelle"];
            this.profession = _data["Profession"];
            this.socioProfessinal = _data["SocioProfessinal"];
            this.secteurActivite = _data["SecteurActivite"];
            this.origineFonds = _data["OrigineFonds"];
            this.revenuMensuelle = _data["RevenuMensuelle"];
            this.otherAccount = _data["OtherAccount"];
            this.souscriptionOffre = _data["souscriptionOffre"];
            this.autreSouscriptionOffre = _data["AutreSouscriptionOffre"];
            this.nmBanque = _data["NmBanque"];
            this.canal = _data["canal"];
            this.actEngagement = _data["ActEngagement"] ? MediaFileProspectDto.fromJS(_data["ActEngagement"]) : <any>undefined;
            this.mRERecto = _data["MRERecto"] ? MediaFileProspectDto.fromJS(_data["MRERecto"]) : <any>undefined;
            this.mREVerso = _data["MREVerso"] ? MediaFileProspectDto.fromJS(_data["MREVerso"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InfoProspect {
        data = typeof data === 'object' ? data : {};
        let result = new InfoProspect();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SituationFamilial"] = this.situationFamilial;
        data["PaysNaissance"] = this.paysNaissance;
        data["fonctionnaire"] = this.fonctionnaire;
        data["Motif"] = this.motif;
        data["fatca"] = this.fatca;
        data["SituationProfessionnelle"] = this.situationProfessionnelle;
        data["Profession"] = this.profession;
        data["SocioProfessinal"] = this.socioProfessinal;
        data["SecteurActivite"] = this.secteurActivite;
        data["OrigineFonds"] = this.origineFonds;
        data["RevenuMensuelle"] = this.revenuMensuelle;
        data["OtherAccount"] = this.otherAccount;
        data["souscriptionOffre"] = this.souscriptionOffre;
        data["AutreSouscriptionOffre"] = this.autreSouscriptionOffre;
        data["NmBanque"] = this.nmBanque;
        data["canal"] = this.canal;
        data["ActEngagement"] = this.actEngagement ? this.actEngagement.toJSON() : <any>undefined;
        data["MRERecto"] = this.mRERecto ? this.mRERecto.toJSON() : <any>undefined;
        data["MREVerso"] = this.mREVerso ? this.mREVerso.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IInfoProspect {
    situationFamilial?: string | undefined;
    paysNaissance?: string | undefined;
    fonctionnaire?: boolean | undefined;
    motif?: string | undefined;
    fatca?: boolean | undefined;
    situationProfessionnelle?: number | undefined;
    profession?: string | undefined;
    socioProfessinal?: string | undefined;
    secteurActivite?: string | undefined;
    origineFonds?: string | undefined;
    revenuMensuelle?: string | undefined;
    otherAccount?: boolean | undefined;
    souscriptionOffre?: string | undefined;
    autreSouscriptionOffre?: string | undefined;
    nmBanque?: string | undefined;
    canal?: string | undefined;
    actEngagement?: MediaFileProspectDto | undefined;
    mRERecto?: MediaFileProspectDto | undefined;
    mREVerso?: MediaFileProspectDto | undefined;
}

export class B3GResponseOfListOfProspectOfferDto implements IB3GResponseOfListOfProspectOfferDto {
    result?: ProspectOfferDto[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfProspectOfferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(ProspectOfferDto.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfProspectOfferDto {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfProspectOfferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfProspectOfferDto {
    result?: ProspectOfferDto[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class FileInput implements IFileInput {
    file?: string | undefined;

    constructor(data?: IFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): FileInput {
        data = typeof data === 'object' ? data : {};
        let result = new FileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        return data; 
    }
}

export interface IFileInput {
    file?: string | undefined;
}

export class B3GResponseOfResultMatchingFace implements IB3GResponseOfResultMatchingFace {
    result?: ResultMatchingFace | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfResultMatchingFace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"] ? ResultMatchingFace.fromJS(_data["Result"]) : <any>undefined;
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfResultMatchingFace {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfResultMatchingFace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfResultMatchingFace {
    result?: ResultMatchingFace | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class ResultMatchingFace implements IResultMatchingFace {
    status?: string | undefined;
    info?: string | undefined;
    match?: boolean | undefined;
    probability_level?: number | undefined;
    info_code?: number | undefined;
    cin_face?: string | undefined;
    reflection?: boolean | undefined;
    probability_msg?: string | undefined;
    trust_cin?: boolean | undefined;

    constructor(data?: IResultMatchingFace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.info = _data["info"];
            this.match = _data["match"];
            this.probability_level = _data["probability_level"];
            this.info_code = _data["info_code"];
            this.cin_face = _data["cin_face"];
            this.reflection = _data["reflection"];
            this.probability_msg = _data["probability_msg"];
            this.trust_cin = _data["trust_cin"];
        }
    }

    static fromJS(data: any): ResultMatchingFace {
        data = typeof data === 'object' ? data : {};
        let result = new ResultMatchingFace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["info"] = this.info;
        data["match"] = this.match;
        data["probability_level"] = this.probability_level;
        data["info_code"] = this.info_code;
        data["cin_face"] = this.cin_face;
        data["reflection"] = this.reflection;
        data["probability_msg"] = this.probability_msg;
        data["trust_cin"] = this.trust_cin;
        return data; 
    }
}

export interface IResultMatchingFace {
    status?: string | undefined;
    info?: string | undefined;
    match?: boolean | undefined;
    probability_level?: number | undefined;
    info_code?: number | undefined;
    cin_face?: string | undefined;
    reflection?: boolean | undefined;
    probability_msg?: string | undefined;
    trust_cin?: boolean | undefined;
}

export class FaceMatchingDto implements IFaceMatchingDto {
    id?: string | undefined;
    identityPhoto?: string | undefined;
    selfie?: string | undefined;

    constructor(data?: IFaceMatchingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.identityPhoto = _data["IdentityPhoto"];
            this.selfie = _data["Selfie"];
        }
    }

    static fromJS(data: any): FaceMatchingDto {
        data = typeof data === 'object' ? data : {};
        let result = new FaceMatchingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["IdentityPhoto"] = this.identityPhoto;
        data["Selfie"] = this.selfie;
        return data; 
    }
}

export interface IFaceMatchingDto {
    id?: string | undefined;
    identityPhoto?: string | undefined;
    selfie?: string | undefined;
}

export class B3GResponseOfCroppingFaceCIN implements IB3GResponseOfCroppingFaceCIN {
    result?: CroppingFaceCIN | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfCroppingFaceCIN) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"] ? CroppingFaceCIN.fromJS(_data["Result"]) : <any>undefined;
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfCroppingFaceCIN {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfCroppingFaceCIN();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfCroppingFaceCIN {
    result?: CroppingFaceCIN | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class CroppingFaceCIN implements ICroppingFaceCIN {
    status?: string | undefined;
    info?: string | undefined;
    cin_face?: string | undefined;

    constructor(data?: ICroppingFaceCIN) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.info = _data["info"];
            this.cin_face = _data["cin_face"];
        }
    }

    static fromJS(data: any): CroppingFaceCIN {
        data = typeof data === 'object' ? data : {};
        let result = new CroppingFaceCIN();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["info"] = this.info;
        data["cin_face"] = this.cin_face;
        return data; 
    }
}

export interface ICroppingFaceCIN {
    status?: string | undefined;
    info?: string | undefined;
    cin_face?: string | undefined;
}

export class OffersInput implements IOffersInput {
    productId?: number | undefined;
    offerId?: number | undefined;
    canal?: string | undefined;
    justificatifPensionRetraite?: MediaFileProspectDto | undefined;

    constructor(data?: IOffersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["ProductId"];
            this.offerId = _data["OfferId"];
            this.canal = _data["canal"];
            this.justificatifPensionRetraite = _data["JustificatifPensionRetraite"] ? MediaFileProspectDto.fromJS(_data["JustificatifPensionRetraite"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OffersInput {
        data = typeof data === 'object' ? data : {};
        let result = new OffersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProductId"] = this.productId;
        data["OfferId"] = this.offerId;
        data["canal"] = this.canal;
        data["JustificatifPensionRetraite"] = this.justificatifPensionRetraite;
        return data; 
    }
}

export interface IOffersInput {
    productId?: number | undefined;
    offerId?: number | undefined;
    canal?: string | undefined;
    justificatifPensionRetraite?: MediaFileProspectDto | undefined;
}

export class B3GResponseOfListOfSocioProfessionnell implements IB3GResponseOfListOfSocioProfessionnell {
    result?: SocioProfessionnell[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfSocioProfessionnell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(SocioProfessionnell.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfSocioProfessionnell {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfSocioProfessionnell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfSocioProfessionnell {
    result?: SocioProfessionnell[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class SocioProfessionnell implements ISocioProfessionnell {
    id?: number | undefined;
    codeCategorieSocioProfessional?: string | undefined;
    libelleCodeSocioProfessional?: string | undefined;

    constructor(data?: ISocioProfessionnell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.codeCategorieSocioProfessional = _data["CodeCategorieSocioProfessional"];
            this.libelleCodeSocioProfessional = _data["LibelleCodeSocioProfessional"];
        }
    }

    static fromJS(data: any): SocioProfessionnell {
        data = typeof data === 'object' ? data : {};
        let result = new SocioProfessionnell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["CodeCategorieSocioProfessional"] = this.codeCategorieSocioProfessional;
        data["LibelleCodeSocioProfessional"] = this.libelleCodeSocioProfessional;
        return data; 
    }
}

export interface ISocioProfessionnell {
    id?: number | undefined;
    codeCategorieSocioProfessional?: string | undefined;
    libelleCodeSocioProfessional?: string | undefined;
}

export class B3GResponseOfListOfProfessionOutput implements IB3GResponseOfListOfProfessionOutput {
    result?: ProfessionOutput[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfProfessionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(ProfessionOutput.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfProfessionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfProfessionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfProfessionOutput {
    result?: ProfessionOutput[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class ProfessionOutput implements IProfessionOutput {
    id?: number | undefined;
    labelCodeProfession?: string | undefined;
    codeSocioProfessionelle?: string | undefined;
    codeProfession?: string | undefined;

    constructor(data?: IProfessionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.labelCodeProfession = _data["LabelCodeProfession"];
            this.codeSocioProfessionelle = _data["CodeSocioProfessionelle"];
            this.codeProfession = _data["CodeProfession"];
        }
    }

    static fromJS(data: any): ProfessionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["LabelCodeProfession"] = this.labelCodeProfession;
        data["CodeSocioProfessionelle"] = this.codeSocioProfessionelle;
        data["CodeProfession"] = this.codeProfession;
        return data; 
    }
}

export interface IProfessionOutput {
    id?: number | undefined;
    labelCodeProfession?: string | undefined;
    codeSocioProfessionelle?: string | undefined;
    codeProfession?: string | undefined;
}

export class B3GResponseOfListOfProspectMediContent implements IB3GResponseOfListOfProspectMediContent {
    result?: ProspectMediContent[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfProspectMediContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(ProspectMediContent.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfProspectMediContent {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfProspectMediContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfProspectMediContent {
    result?: ProspectMediContent[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class ProspectMediContent implements IProspectMediContent {
    id?: number | undefined;
    description?: string | undefined;
    name?: string | undefined;
    fileContent?: string | undefined;
    mimeType?: string | undefined;
    type?: string | undefined;

    constructor(data?: IProspectMediContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.description = _data["Description"];
            this.name = _data["Name"];
            this.fileContent = _data["FileContent"];
            this.mimeType = _data["MimeType"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): ProspectMediContent {
        data = typeof data === 'object' ? data : {};
        let result = new ProspectMediContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Description"] = this.description;
        data["Name"] = this.name;
        data["FileContent"] = this.fileContent;
        data["MimeType"] = this.mimeType;
        data["Type"] = this.type;
        return data; 
    }
}

export interface IProspectMediContent {
    id?: number | undefined;
    description?: string | undefined;
    name?: string | undefined;
    fileContent?: string | undefined;
    mimeType?: string | undefined;
    type?: string | undefined;
}

export class StatisOCR implements IStatisOCR {
    ocrTimeOUT?: boolean | undefined;
    ocrFailed?: boolean | undefined;
    ocrPasser?: boolean | undefined;

    constructor(data?: IStatisOCR) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ocrTimeOUT = _data["ocrTimeOUT"];
            this.ocrFailed = _data["ocrFailed"];
            this.ocrPasser = _data["ocrPasser"];
        }
    }

    static fromJS(data: any): StatisOCR {
        data = typeof data === 'object' ? data : {};
        let result = new StatisOCR();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ocrTimeOUT"] = this.ocrTimeOUT;
        data["ocrFailed"] = this.ocrFailed;
        data["ocrPasser"] = this.ocrPasser;
        return data; 
    }
}

export interface IStatisOCR {
    ocrTimeOUT?: boolean | undefined;
    ocrFailed?: boolean | undefined;
    ocrPasser?: boolean | undefined;
}

export class B3GResponseOfBoolean implements IB3GResponseOfBoolean {
    result?: boolean | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"];
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result;
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfBoolean {
    result?: boolean | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class B3GResponseOfListOfProspectProductDto implements IB3GResponseOfListOfProspectProductDto {
    result?: ProspectProductDto[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfListOfProspectProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(ProspectProductDto.fromJS(item));
            }
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfListOfProspectProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfListOfProspectProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfListOfProspectProductDto {
    result?: ProspectProductDto[] | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class B3GResponseOfOfferDto implements IB3GResponseOfOfferDto {
    result?: OfferDto | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;

    constructor(data?: IB3GResponseOfOfferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"] ? OfferDto.fromJS(_data["Result"]) : <any>undefined;
            this.statusCode = _data["StatusCode"];
            if (Array.isArray(_data["Validation"])) {
                this.validation = [] as any;
                for (let item of _data["Validation"])
                    this.validation!.push(Validation.fromJS(item));
            }
            this.label = _data["Label"];
        }
    }

    static fromJS(data: any): B3GResponseOfOfferDto {
        data = typeof data === 'object' ? data : {};
        let result = new B3GResponseOfOfferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["StatusCode"] = this.statusCode;
        if (Array.isArray(this.validation)) {
            data["Validation"] = [];
            for (let item of this.validation)
                data["Validation"].push(item.toJSON());
        }
        data["Label"] = this.label;
        return data; 
    }
}

export interface IB3GResponseOfOfferDto {
    result?: OfferDto | undefined;
    statusCode?: string | undefined;
    validation?: Validation[] | undefined;
    label?: string | undefined;
}

export class OfferDto implements IOfferDto {
    id?: number | undefined;
    label?: string | undefined;
    picture?: string | undefined;
    offerType?: number | undefined;

    constructor(data?: IOfferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.label = _data["Label"];
            this.picture = _data["Picture"];
            this.offerType = _data["OfferType"];
        }
    }

    static fromJS(data: any): OfferDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Label"] = this.label;
        data["Picture"] = this.picture;
        data["OfferType"] = this.offerType;
        return data; 
    }
}

export interface IOfferDto {
    id?: number | undefined;
    label?: string | undefined;
    picture?: string | undefined;
    offerType?: number | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}